import React from "react";
import "./Artist_Profile.css";
import { useState, useEffect, useRef } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "../../FrontPage/Navbar.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IoMicOutline } from "react-icons/io5";
import indianStatesAndCities from "../../../data/indian_states_cities";
import Sidebar from "../../../components/Sidebar";
import {
  makeAuthenticatedGETRequest,
  makeAuthenticatedPATCHRequest,
  makeAuthenticatedPOSTRequest,
  makeAuthenticatedDELETERequest,
  makeAuthenticated_Multi_Patch_REQ,
} from "../../services/serverHelper";
import { FaShoppingCart } from "react-icons/fa";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { artistProfilePoints, productPoints } from "../../services/apis";
import {useNavigate, useSearchParams} from "react-router-dom";
import Artist_navbar from "../Artist_navbar";
import art from "./assets/art.svg";
import star from "./assets/star.svg";
import performance from "./assets/performance.svg";
import Facebook from "./assets/Facebook.svg";
import Instagram from "./assets/Instagram.svg";
import Globe from "./assets/Globe.svg";
import LinkedIn from "./assets/LinkedIn.svg";
import TwitterX from "./assets/TwitterX.svg";
import YouTube from "./assets/YouTube.svg";
import {
  specialization,
  languages,
  typeOfArt,
  artform,
  performanceduration,
  artTypeData,
  performancetype,
  natureofArt,
  nameofart,
  courses,
  categories,
  disabilitiesArray,
  highestLevelOfPerformance,
  ChargesPerPerformance,
  artInfo1,
  indian_cities,
  indian_states,
  moods,
} from "../../Data/artistProfile";
import Select from "react-select";

import { purpose } from "../../products/ProductList";

export function Artist_Profile() {
  const { accessToken } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  
  // const defaultPic =
  let defaultPic =
    "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png";
  // const defaultPic =
  //   "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png";

  const initialActiveSection = "basic";

  const [activeSection, setActiveSection] = useState(initialActiveSection);
  const [art, setArt] = useState([]);
  const [artName, setArtName] = useState("");
  const [artTypes, setArtTypes] = useState("");
  const [newCategory, setNewCategory] = useState("");
  const [anyLanguage, setAnyLanguage] = useState("");
  const [count, setCount] = useState(0);
  const [rotation, setRotation] = useState(0);
  const [chiku,setChiku] = useState([])
  const [moodsoptions, setMoodOptions] = useState([]);
  const [languagesProductOptions, setlanguagesProductOptions] = useState(null);
  const [formData, setFormData] = useState(
    {
      artist: localStorage.getItem('artId'),
    //   title: '',
    //   category: '',
    //   subCategory: '',
    //   language:"",
    //   tags: [],
    //   video: {
    //     youtubeId: '',
    //     url: '',
    //     trailerURL: '',
    //     visibility: '',
    //     duration: '',
    //     quality: ''
    //   },
    //   description: '',
    //   culturalType: '',
    //   moods: moodsoptions,
    //   pricing: {
    //     amount: '',
    //     currency: 'INR'
    //   }
    }
  );
  const [searchParams, setSearchParams] = useSearchParams();
const [isVerified, setIsVerified] = useState(false);
// Add this state for multiple productions
const [productions, setProductions] = useState([
  {
    nameOfProductions: "",
    briefOfPerformance: "",
    approxBudget: 0,
    sample: "",
  },
]);


const allCities = Object.values(indianStatesAndCities).flat();
const locationOptions = allCities.map((city) => ({
  value: city,
  label: city,
}));


  const [selectedTitleName, setSelectedTitleName] = useState('');
  const [selectedCategoryName, setSelectedCategoryName] = useState('');
  const [selectedSubcategoryName, setSelectedSubcategoryName] = useState('');
  const [selectedArtForm, setSelectedArtForm] = useState('');

  // 2. Find the object for the currently selected category
  const currentCategoryObj = purpose.find(
    (item) => item.category === selectedTitleName
  );

  // 3. Find the object for the currently selected subcategory
  const currentSubcategoryObj = currentCategoryObj?.subcategories.find(
    (sub) => sub.name === selectedCategoryName
  );

  // 4. Handle parent changes (reset children states to avoid bugs)
  const handleTitleChange = (e) => {
    setFormData(prev => ({...prev, title: e.target.value}) )
    console.log(e.target.value);
    setSelectedTitleName(e.target.value);
    setSelectedCategoryName(''); // Reset subcategory
    setSelectedArtForm('');         // Reset art form
  };

  const handleCategoryChange = (e) => {
    setFormData(prev => ({...prev, category: e.target.value}) )
    console.log(e.target.value);
    setSelectedCategoryName(e.target.value);
    setSelectedArtForm('');         // Reset art form
  };

  const handleSubCategoryChange = (e) => {
    setSelectedSubcategoryName(e.target.value)
    setFormData(prev => ({...prev, subCategory: e.target.value}));
    setSelectedArtForm('');  
  }



// Handler to add new production row
const addProductionRow = () => {
  setProductions([...productions, { nameOfProductions: "", briefOfPerformance: "", approxBudget: 0, sample: "" }]);
};

// Handler to remove production row
const removeProductionRow = (index) => {
  const updated = productions.filter((_, i) => i !== index);
  setProductions(updated.length > 0 ? updated : [{ nameOfProductions: "", briefOfPerformance: "", approxBudget: 0, sample: "" }]);
};

// Handler for production input changes
const handleProductionChange = (index, field, value) => {
  const updated = [...productions];
  updated[index][field] = value;
  setProductions(updated);
};

// Handler for file upload per row
const handleProductionSampleUpload = (index, e) => {
  const file = e.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = (event) => {
      const updated = [...productions];
      updated[index].sample = event.target.result;
      setProductions(updated);
    };
    reader.readAsDataURL(file);
  }
};

const getFullImageUrl = (imageValue) => {
    if (!imageValue) return "/default-avatar.png";

    try {
      let raw = String(imageValue).replace(/[\u0000-\u001F\u007F]+/g, "").trim();
      if (!raw) return "/default-avatar.png";

      // blob URL (local preview)
      if (raw.startsWith("blob:")) return raw;

      // If string contains absolute URL anywhere (sometimes backend returns weird concatenation), extract first http(s)
      const absMatch = raw.match(/https?:\/\/[^\s]+/i);
      if (absMatch && absMatch[0]) {
        // return absolute URL directly (preserve)
        return absMatch[0];
      }

      // protocol-relative
      if (raw.startsWith("//")) return "https:" + raw;

      // strip leading slashes and common prefixes
      let cleaned = raw
        .replace(/^\/+/, "")
        .replace(/^public\/images\//i, "")
        .replace(/^public\/uploads\//i, "")
        .replace(/^uploads\/performance\//i, "")
        .replace(/^uploads\//i, "")
        .replace(/^images\//i, "")
        .replace(/^api\/v1\/images\//i, "")
        .replace(/^api\/images\//i, "")
        .replace(/^https?:\/\/api\.ekalakaar\.com\/api\/v1\/images\//i, "")
        .replace(/^https?:\/\/api\.ekalakaar\.com\/uploads\/performance\//i, "")
        .replace(/^https?:\/\/api\.ekalakaar\.com\//i, "")
        .trim();

      // Build host from env or default
      const envBase = process.env.REACT_APP_BASE_URL || "https://api.ekalakaar.com";
      // Ensure we keep only host (strip any /api/v1 etc)
      let API_HOST = String(envBase).replace(/\/api(\/v?1)?(\/.*)?$/i, "").replace(/\/+$/i, "");
      if (!API_HOST.startsWith("http")) {
        API_HOST = "https://" + API_HOST;
      }

      // Use /images/<filename> endpoint which your backend serves
      return `${API_HOST}/images/${cleaned}`;
    } catch (err) {
      console.error("getFullImageUrl error:", err, imageValue);
      return "/default-avatar.png";
    }
  };


  //Profile Prograss Bar
  // const calculateProgressPercentage = () => {
  //   // Your logic to calculate the progress percentage
  //   // Replace this with the actual logic based on your form data
  //   const totalFields = 40;
  //   const filledFields = 20;
  //   const percentage = (filledFields / totalFields) * 100;
  //   const rotation = (percentage / 100) * 360;
  //   setRotation(rotation);
  //   return percentage;
  // };

  const calculateProgressPercentage = () => {
    const totalFields = 12;
    const requiredFields = ['firstName', 'lastName', 'age', 'email', 'contactNumber', 'gender', 'languages', 'pincode',  'artinfo.artCategory', 'artinfo.artName', 'performanceInfo.experience', 'performanceInfo.totalPerfs'];

    const filledCount = requiredFields.filter(key => {
      const val = basicFormData[key];

      // A field is filled if:
      return val !== null
    }).length;
    console.log("filledCount", filledCount)

  // const totalFields = Object.keys(basicFormData).length;
  //   const filledFields = 20;
    const percentage = (filledCount / totalFields) * 100;
    const rotation = (percentage / 100) * 360;
    console.log(rotation)
    setCount(percentage);
    setRotation(rotation)
    // return percentage;
  };


  const numbersArray = Array.from({ length: 250 }, (_, index) => index + 1);
  const years = Array.from(
    { length: 2030 - 1950 + 1 },
    (_, index) => index + 1950
  );
  const months = Array.from({ length: 24 }, (_, index) => index + 1);
  const documentList = [
    "Aadhar Card (India)",
    "Bank Statement (with matching address)",
    "Birth Certificate",
    "Driver's License",
    "National ID Card",
    "PAN Card (India)",
    "Passport",
    "Social Security Card",
  ];
  const indianStates = [
    "Andaman and Nicobar Islands",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra and Nagar Haveli",
    "Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Puducherry",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];

  const [toggle, setToggle] = useState([
    { name: "Language", isActive: false },
    { name: "Object 2", isActive: false },
    { name: "Object 3", isActive: false },
  ]);

  const MajorInternationalCities = [
    "Bangladesh",
    "Brazil",
    "China",
    "Colombia",
    "DR Congo",
    "Egypt",
    "Ethiopia",
    "France",
    "Germany",
    "India",
    "Indonesia",
    "Iran",
    "Italy",
    "Japan",
    "Mexico",
    "Myanmar",
    "Nigeria",
    "Pakistan",
    "Philippines",
    "Russia",
    "South Africa",
    "South Korea",
    "Spain",
    "Tanzania",
    "Thailand",
    "Turkey",
    "United Kingdom",
    "United States",
    "Vietnam",
  ];



  const MajorIndianCities = [
  "Mumbai",
  "Delhi",
  "Bengaluru",
  "Hyderabad",
  "Ahmedabad",
  "Chennai",
  "Kolkata",
  "Pune",
  "Surat",
  "Jaipur",
  "Lucknow",
  "Kanpur",
  "Nagpur",
  "Indore",
  "Bhopal",
  "Patna",
  "Vadodara",
  "Ghaziabad",
  "Agra",
  "Nashik",
  "Faridabad",
  "Meerut",
  "Rajkot",
  "Kalyan-Dombivli",
  "Vasai-Virar",
  "Varanasi",
  "Srinagar",
  "Aurangabad",
  "Dhanbad",
  "Amritsar",
  "Navi Mumbai",
  "Allahabad (Prayagraj)",
  "Howrah",
  "Ranchi",
  "Coimbatore",
  "Jodhpur",
  "Madurai",
  "Guwahati",
  "Thane",
  "Gwalior",
  "Jalandhar",
  "Bhubaneswar",
  "Salem",
  "Warangal",
  "Tiruchirappalli",
  "Mangalore",
  "Mysuru",
  "Tirupati",
  "Jamshedpur",
  "Ujjain"
];

  const languageOptions = languages.map((item) => ({
    value: item,
    label: item,
  }));

  const MAX_MOODS = 5;

  const moodOptions = moods.map((item) => ({
    value: item,
    label: item,
  }));

const handleMoodChange = (selectedOptions) => {
  const values = selectedOptions || [];
  console.log(values);
  if (values.length <= 5) {
    setMoodOptions(values);
    setFormData(prev => ({...prev, moodTags:values}))
  }
};

  const handleLanguageChange = (selectedOptions) => {
    setlanguagesProductOptions(selectedOptions);
    setFormData(prev => ({...prev, language: selectedOptions}));
};

const categoryOfArt = artInfo1.map((item) => ({
    value: item.art,
    label: item.art,
  }));

  const majorCities = MajorIndianCities.map((item) => ({
    value: item,
    label: item,
  }));

  const majorContry = MajorInternationalCities.map((item) => ({
    value: item,
    label: item,
  }));

  //multiple select for art profile
  const Dance = [
    "Bharatanatyam",
    "Bihu",
    "Chhau",
    "Dandiya Raas",
    "Dollu Kunitha",
    "Dumhal",
    "Garba",
    "Gaur Dance",
    "Giddha",
    "Gotipua",
    "Jhumar",
    "Kacchi Ghodi",
    "Kalbelia",
    "Karakattam",
    "Kathak",
    "Kathakali",
    "Kathakar",
    "Koli",
    "Kuchipudi",
    "Lavani",
    "Manipuri",
    "Mayurbhanj Chhau",
    "Mohiniyattam",
    "Odissi",
    "Raas Leela",
    "Sattriya",
    "Tamasha",
    "Tera Tali",
    "Thang-Ta",
    "Yakshagana",
    "Any Other",
  ];
  const Song = [
    "Dhrupad",
    "Khayal",
    "Thumri",
    "Tappa",
    "Ghazal",
    "Qawwali",
    "Kriti",
    "Varnam",
    "Tillana",
    "Ragamalika",
    "Javali",
    "Swarajati",
    "Bhajans",
    "Kirtan",
    "Sufi Music",
    "Abhangas",
    "Shabad Kirtan (Sikh)",
    "Any Other",
  ];
  const Theatre = [
    "Bhavai",
    "Bhand Pather",
    "Jatra",
    "Koodiyattam",
    "Mudiyettu",
    "Nautanki",
    "Pandavani",
    "Pothu Koothu",
    "Ramlila",
    "Ram Lila",
    "Ras Leela",
    "Sattriya",
    "Tamaasha",
    "Therukoothu",
    "Yakshagana",
    "Any Other",
  ];
  const Music = [
    "Bansuri",
    "Dilruba",
    "Dholak",
    "Ektara",
    "Esraj",
    "Flute (Bansuri)",
    "Ghatam",
    "Harmonium",
    "Jal Tarang",
    "Mridangam",
    "Nadaswaram",
    "Pakhawaj",
    "Ravanahatha",
    "Sarangi",
    "Sarod",
    "Santoor",
    "Shehnai",
    "Sitar",
    "Tabla",
    "Tanpura",
    "Tumbi",
    "Veena",
    "Any Other",
  ];
  const Any_Other = ["Any Other"];

  const artdata = {
    Dance: Dance,
    Song: Song,
    Theatre: Theatre,
    Music: Music,
  };

  const [languagesoptions, setlanguagesoptions] = useState(null);
  
  const [categoryOption, setCategoryOption] = useState([]);
  const [artNameOption, setArtNameOption] = useState([]);
  const [artOption, setArtOption] = useState([]);
  const [cities, setCities] = useState(null);
  const [country, setCountry] = useState(null);
  const [nameOfArt, setnameOfArt] = useState([]);

  useEffect(() => {
    const newProgress = calculateProgressPercentage();
    console.log("newProgress", newProgress);
    // setCount(newProgress);
    if (categoryOption === null || categoryOption.length === 0) {
      setnameOfArt([]);
      return;
    }
    const dataart = categoryOption?.map((option) => option.value);
    const newOptions = dataart?.flatMap((item) =>
      artdata[item]?.map((subItem) => ({ value: subItem, label: subItem }))
    );
    setnameOfArt(newOptions);
  
  }, [categoryOption]);


  const typeOfArts = typeOfArt.map((item) => ({
    value: item,
    label: item,
  }));

  const perfArtName = [
    "Bharatanatyam",
    "Bihu",
    "Chhau",
    "Dandiya Raas",
    "Dollu Kunitha",
    "Dumhal",
    "Garba",
    "Gaur Dance",
    "Giddha",
    "Gotipua",
    "Jhumar",
    "Kacchi Ghodi",
    "Kalbelia",
    "Karakattam",
    "Kathak",
    "Kathakali",
    "Kathakar",
    "Koli",
    "Kuchipudi",
    "Lavani",
    "Manipuri",
    "Mayurbhanj Chhau",
    "Mohiniyattam",
    "Odissi",
    "Raas Leela",
    "Sattriya",
    "Tamasha",
    "Tera Tali",
    "Thang-Ta",
    "Yakshagana",
    /// Song
  "Dhrupad", "Khayal", "Thumri", "Tappa", "Ghazal", "Qawwali", "Kriti", 
  "Varnam", "Tillana", "Ragamalika", "Javali", "Swarajati", "Bhajans", 
  "Kirtan", "Sufi Music", "Abhangas", "Shabad Kirtan (Sikh)",
  
  // Theatre
  "Bhavai", "Bhand Pather", "Jatra", "Koodiyattam", "Mudiyettu", "Nautanki", 
  "Pandavani", "Pothu Koothu", "Ramlila", "Ram Lila", "Ras Leela", "Sattriya", 
  "Tamaasha", "Therukoothu", "Yakshagana",
  
  // Music
  "Bansuri", "Dilruba", "Dholak", "Ektara", "Esraj", "Flute (Bansuri)", 
  "Ghatam", "Harmonium", "Jal Tarang", "Mridangam", "Nadaswaram", "Pakhawaj", 
  "Ravanahatha", "Sarangi", "Sarod", "Santoor", "Shehnai", "Sitar", "Tabla", 
  "Tanpura", "Tumbi", "Veena",
  
  "Any Other"
  ];



  // ! this is for avatar
  // const [profileAvatar, setProfileAvatar] = useState(null);
  const [profileAvatar, setProfileAvatar] = useState(defaultPic);
  // ! this is for avatar
  // const [profileAvatar, setProfileAvatar] = useState(null);

  const handleClick = (section) => {
    setActiveSection(section);
    localStorage.setItem("activeSection", section);
  };

  const statesOFIndiaData = [
    {
      key: "AN",
      name: "Andaman and Nicobar Islands",
    },
    {
      key: "AP",
      name: "Andhra Pradesh",
    },
    {
      key: "AR",
      name: "Arunachal Pradesh",
    },
    {
      key: "AS",
      name: "Assam",
    },
    {
      key: "BR",
      name: "Bihar",
    },
    {
      key: "CG",
      name: "Chandigarh",
    },
    {
      key: "CH",
      name: "Chhattisgarh",
    },
    {
      key: "DH",
      name: "Dadra and Nagar Haveli",
    },
    {
      key: "DD",
      name: "Daman and Diu",
    },
    {
      key: "DL",
      name: "Delhi",
    },
    {
      key: "GA",
      name: "Goa",
    },
    {
      key: "GJ",
      name: "Gujarat",
    },
    {
      key: "HR",
      name: "Haryana",
    },
    {
      key: "HP",
      name: "Himachal Pradesh",
    },
    {
      key: "JK",
      name: "Jammu and Kashmir",
    },
    {
      key: "JH",
      name: "Jharkhand",
    },
    {
      key: "KA",
      name: "Karnataka",
    },
    {
      key: "KL",
      name: "Kerala",
    },
    {
      key: "LD",
      name: "Lakshadweep",
    },
    {
      key: "MP",
      name: "Madhya Pradesh",
    },
    {
      key: "MH",
      name: "Maharashtra",
    },
    {
      key: "MN",
      name: "Manipur",
    },
    {
      key: "ML",
      name: "Meghalaya",
    },
    {
      key: "MZ",
      name: "Mizoram",
    },
    {
      key: "NL",
      name: "Nagaland",
    },
    {
      key: "OR",
      name: "Odisha",
    },
    {
      key: "PY",
      name: "Puducherry",
    },
    {
      key: "PB",
      name: "Punjab",
    },
    {
      key: "RJ",
      name: "Rajasthan",
    },
    {
      key: "SK",
      name: "Sikkim",
    },
    {
      key: "TN",
      name: "Tamil Nadu",
    },
    {
      key: "TS",
      name: "Telangana",
    },
    {
      key: "TR",
      name: "Tripura",
    },
    {
      key: "UK",
      name: "Uttar Pradesh",
    },
    {
      key: "UP",
      name: "Uttarakhand",
    },
    {
      key: "WB",
      name: "West Bengal",
    },
  ];

  const completionYearData = [
    2027, 2026, 2025, 2024, 2023, 2022, 2021, 2020, 
2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 
2011, 2010, 2009, 2008, 2007, 2006, 2005, 2004, 
2003, 2002, 2001, 2000, 1999, 1998, 1997, 1996, 
1995, 1994, 1993, 1992, 1991, 1990, 1989, 1988, 
1987, 1986, 1985, 1984, 1983, 1982, 1981,
  ];
  // !  for basic proile
  const [basicFormData, setBasicFormData] = useState({
    firstName: "",
    highestEducation: "",
    yearOfCompletion: "",
    lastName: "",
    email: "",
    contactNumber: {
      countryCode: "",
      number: "",
    },
    customID: "",
    age: "",
    isVerified:false,
    gender: "",
    languages: [],
    monthlyIncome: "",
    about: "",
    pwd: "",
    incomeSrc: "",
    socialCategory: "",
    idProof: {
      name: "",
      num: "",
    },
    bank: {
      bankAccountNumber: "",
      bankName: "",
      ifscCode: "",
      bankBranchLocation: "",
    },
    address: {
      state: "",
      city: "",
      pincode: "",
      details: "",
    },
    anunalIncomeByPerf: "",
    numOfperformanceLastYear: "",
    handles: {
      instagram: "",
      facebook: "",
      youtube: "",
      linkedIn: "",
      website: "",
      twitter: "",
    },
    gstIn: "",
    aadharNumber: "",
    panNumber: "",
    upiId: "",
    passportNumber: "",
  });
  const [numberOfAward, setNumberOfAward] = useState("");
  const [hightLevel, sethightLevel] = useState("");
  

  const PinFetch = async (value) => {
    try {
      if (value.length === 6) {
        const url = `https://api.postalpincode.in/pincode/` + value;
        const Responce = await fetch(url);
        const data = await Responce.json();
        // console.log("checkPin",data[0].Status);
        if (data[0].Status === "Success") {
          setBasicFormData((prev) => ({
            ...prev,
            address: {
              ...prev.address,
              state: data[0].PostOffice[0].State,
              city: data[0].PostOffice[0].District,
            },
          }));
    

        } else {
          toast.error("PIN Code not found");
        }
      } else {
        setBasicFormData((prev) => ({
          ...prev,
          address: {
            ...prev.address,
            state: "",
            city: "",
          },
        }));
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const changeHandler = (event) => {
    const { name, value } = event.target;
    const filledFields = Object.values(basicFormData).filter(
      (field) => field
    ).length;
    const tryy = Object.values(basicFormData).sort().reverse().slice(0, 5);


    setNumberOfAward(value);
    sethightLevel(value);
    if (name.startsWith("address.")) {
      // If the change is related to address, update the nested state
      PinFetch(value);
      setBasicFormData((prevData) => ({
        ...prevData,
        address: {
          ...prevData.address,
          [name.split(".")[1]]: value,
        },
      }));
    } else if (name.startsWith("handles.")) {
      setBasicFormData((prevData) => ({
        ...prevData,
        handles: {
          ...prevData.handles,
          [name.split(".")[1]]: value,
        },
      }));
    } else if (name.startsWith("contactNumber.")) {
      setBasicFormData((prevData) => ({
        ...prevData,
        contactNumber: {
          ...prevData.contactNumber,
          [name.split(".")[1]]: value,
        },
      }));
    } else if (name.startsWith("idProof.")) {
      setBasicFormData((prevData) => ({
        ...prevData,
        idProof: {
          ...prevData.idProof,
          [name.split(".")[1]]: value,
        },
      }));
      // }else if (name.startsWith("Date")) {
      //   setBasicFormData((prevData) => ({
      //     ...prevData,
      //     passportNumber:event.getFullYear()
      //   }));
    } else {
      // Otherwise, update the top-level state
      setBasicFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const [errors, setErrors] = useState({});
  //   ! submit update handler for basic profile
  const basicSubmitHandler = async (event) => {
    event.preventDefault();

    const toastId = toast.loading("Loading...");

    let address = basicFormData.address;
    let idProof = basicFormData.idProof;

    let {
      firstName,
      lastName,
      about,
      age,
      contactNumber: { countryCode, number },
      email,
      gender,
      socialCategory,
      customID,
      monthlyIncome,
      aadharNumber,
      panNumber,
      upiId,

      anunalIncomeByPerf,
      highestEducation,
      yearOfCompletion,
      numOfperformanceLastYear,
      handles,
      pwd,
      incomeSrc,
      gstIn,
    } = basicFormData;

    let personalInfo = {
      firstName,
      lastName,
      about,
      age,
      customID,
      contactNumber: {
        number: number,
        countryCode: countryCode,
      },
      pwd,
      email,
      gender,
      monthlyIncome,
      socialCategory,
      incomeSrc,
    };

    personalInfo.languages = languagesoptions.map((option) => option.value);

    let otherInfo = {
      aadharNumber,
      panNumber,
      upiId,
      numOfperformanceLastYear,
      idProof,
      gstIn,
      anunalIncomeByPerf,
      yearOfCompletion,
      highestEducation,
    };

    otherInfo.passportNumber = startDate;

    let socialLinks = handles;
    // validate
    let isValid = true;
    const newErrors = {};

    if (firstName.trim() === "") {
      isValid = false;
      toast.error("Firstname  is required");
    } else if (!/^[A-Za-z\s]+$/.test(firstName)) {
      toast.error("Please enter only text");
      isValid = false;
    }
    if (personalInfo.contactNumber.number.trim() === "") {
      toast.error("Mobile number is required");
      isValid = false;
    } else if (!/^[0-9]{10}$/.test(personalInfo.contactNumber.number)) {
      toast.error("Please enter a valid 10-digit mobile number");

      isValid = false;
    }

    // Add more validation checks for other fields (e.g., email format, password strength, etc.)

    if (!isValid) {
      setErrors(newErrors);
    } else {
      setErrors({});
      // Proceed with form submission or other actions
    }
    ////
    try {
      const response = await makeAuthenticatedPATCHRequest(
        artistProfilePoints.UPDATE_PROFILE_DATA_API,
        { address, personalInfo, otherInfo, socialLinks },
        accessToken
      );

      if (response.status === "success") {
        toast.success(" successFully updated", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setActiveSection("art");
        localStorage.setItem("activeSection", activeSection);
      } else {
        toast.error(response.message, {
          position: "top-center",
        });
        toast.error("server error please try again", {
          position: "top-center",
        });
      }
    } catch (error) {
      console.log(error);
    }
    toast.dismiss(toastId);
  };

  //   ! for art Profile funtion
  const [artFormData, setArtFormData] = useState({
    natureOfArt: "",
    areaOfInterest: "",
    genre: "",
    artForm: "",
    performanceType: "",
    artEducation: "",
    artName: "",
    nameOfGuru: "",
    traditionArtName: "",
    artEduDuration: {
      start: "",
      end: "",
    },
    yearOfCompletation: "",
    certificateOfArt: "",
    academicQualification: "",
    course: "",
    specialization: "",
    institute: "",
    academicQualificationDuration: {
      start: "",
      end: "",
    },
    certificateOfAcademicQualification: "",
    certificateInstitute: "",
    certificateCourse: "",
    certificateDuration: {
      start: "",
      end: "",
    },
  });
  const [traditionalTable, setTraditionalTable] = useState([
    {
      artName: "",
      guruName: "",
      location: "",
      duration: "",
      completionYear: 0,
      documentUrl: "",
    },
    {
      artName: "",
      guruName: "",
      location: "",
      duration: "",
      completionYear: 0,
      documentUrl: "",
    },
    {
      artName: "",
      guruName: "",
      location: "",
      duration: "",
      completionYear: 0,
      documentUrl: "",
    },
  ]);
  const handleArtProfileChanges = (e, rowIdx, key) => {
    const newData = [...professionalTable];
    newData[rowIdx][key] = e.target.value;
    setProfessionalTable(newData);
  };
  const [artInfoFormData, setArtInfoFormData] = useState({
    aboutArt: "",
    artCategory: [],
    artEducation: "",
    artName: [],
    artType: [],
  });
  // console.log("table",professionalTable);

  const artChangesHandler = (event) => {
    const { name, value } = event.target;
    if (name.startsWith("artCategory")) {
      setArt(artInfo1.find((ctr) => ctr.art === value).category);
      setArtInfoFormData((prev) => ({
        ...prev,
        artCategory: value,
      }));
    } else {
      setArtInfoFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };


  //  ! for performance profile section

  const [tableData, setTableData] = useState([
    // Initial data with column headings
    {
      eventName: "",
      duration: "",
      level: "",
      location: "",
      collaborator: "",
      link: "",
    },
    {
      eventName: "",
      duration: "",
      level: "",
      location: "",
      collaborator: "",
      link: "",
    },
    {
      eventName: "",
      duration: "",
      level: "",
      location: "",
      collaborator: "",
      link: "",
    },
  ]);
  const [performanceFormData, setPerformanceFormData] = useState({
    totalNoOfArtist: "",
    artName: "",
    affiliatedToAnyGroup: Boolean,
    nameOfArtistGroupOrg: "",
    locationOfGroupOrg: "",
     groupLocation: "",
    contactNumber: "",
    countryCode: "",
    typeOfPerformance: "",
    highestLevelOfPerformance: "",
    totalPerfs: "",
    experience: "",
    avgPerfDurationIn: "",
    avgPerfFeeIn: "",
    avgPerfDurationInternational: "",
    avgPerfFeeInternational: "",
    majorPerfCityIndia: "",
    majorPerfCountryInternational: "",
    aboutJourney: "",
    topFivePerformance: [],
    performanceImages: [],
    performancevideos: [],
    localPerformanceImages: [], // New state for local previews
  });
  const [perfInfoData, setPerfInfoData] = useState({
    nameOfArts: "",
    totalNoOfArtists: 0,
    existingProductions: 0,
    nameOfProductions: "",
    briefOfPerformance: "",
    approxBudget: 0,
    samples: [],
  });

  const performanceInfohandler = (event) => {
    const { name, value } = event.target;

    setPerfInfoData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSampleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
      setPerfInfoData({
        ...perfInfoData,
        samples: event.target.result,
      });
    };

    reader.readAsDataURL(file);
  };

  const perforChangeHandler = (event) => {
    const { name, value } = event.target;

    if (name.startsWith("topFivePerformance.")) {
      // Parse the index from the name
      const index = parseInt(name.replace("topFivePerformance.", ""), 10);

      // Create a copy of the current topFivePerformance array
      const updatedPerformanceArray = [
        ...performanceFormData.topFivePerformance,
      ];

      // Update the specific element at the index with the new value
      updatedPerformanceArray[index] = value;

      // Update the performanceFormData state with the modified array
      setPerformanceFormData((prevData) => ({
        ...prevData,
        topFivePerformance: updatedPerformanceArray,
      }));
    } else {
      // Handle other form fields as needed
      setPerformanceFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const perforSubmitHandler = async (event) => {
    console.log("clicked");
    event.preventDefault();
    // console.log("PERF INFO - >", perfInfoData);

    const toastId = toast.loading("Loading...");

    // uploading Videos
    if (perfVideo !== "") {
      const VideosLinks = perfVideo.map((item) => item.trim());
      console.log(VideosLinks);
      const formData = new FormData();
      formData.append("videoUrls", VideosLinks[0]);
      formData.append("videoUrls", VideosLinks[1]);
      formData.append("videoUrls", VideosLinks[2]);

      try {
        const videoApiResponse = await makeAuthenticated_Multi_Patch_REQ(
          artistProfilePoints.UPLOAD_PERF_VIDEOS,
          formData,
          accessToken
        );
        console.log("Upload Video Response", videoApiResponse);
      } catch (error) {
        console.log("Upload Video Error", error);
      }
    }

    try {
      const {
        affiliatedToAnyGroup,
        nameOfArtistGroupOrg,
        locationOfGroupOrg,
        contactNumber,
        countryCode,
        typeOfPerformance,
        highestLevelOfPerformance,
        totalPerfs,
        experience,
        avgPerfDurationIn,
        avgPerfFeeIn,
        avgPerfDurationInternational,
        avgPerfFeeInternational,
        aboutJourney,
        majorPerfCountryInternational,
        performanceImages,
        // performancevideos,
      } = performanceFormData;


      let performanceInfo = {
  affiliation: {
    name: nameOfArtistGroupOrg,
    isAffiliated: affiliatedToAnyGroup,
    location: locationOfGroupOrg,
    contactNumber: {
      countryCode: countryCode,
      number: contactNumber,
    },
  },
  perfDuration: {
    india: avgPerfDurationIn,
    international: avgPerfDurationInternational,
  },
  perfCharge: {
    india: avgPerfFeeIn,
    international: avgPerfFeeInternational,
  },
  perfType: typeOfPerformance,
  experience: experience,
  highlights: aboutJourney,
  totalPerfs: totalPerfs,
  peakPerf: highestLevelOfPerformance,
  majorPerfCountry: majorPerfCountryInternational,
  majorPerfCities: cities?.map(option => option.value) || [], 
  perfDetails: tableData, 
  perfImgs: performanceImages,
  perfVideos: perfVideo.filter(url => url.trim() !== ''), 
  // performances: [
  //   {
  //     nameOfArts: perfInfoData.nameOfArts,
  //     totalNoOfArtists: perfInfoData.totalNoOfArtists,
  //     existingProductions: perfInfoData.existingProductions,
  //     nameOfProductions: perfInfoData.nameOfProductions,
  //     briefOfPerformance: perfInfoData.briefOfPerformance,
  //     approxBudget: perfInfoData.approxBudget,
  //     sample: perfInfoData.sample,
  //   },
  // ],

  // In perforSubmitHandler, replace the performances array with:
performances: productions.map(p => ({
  nameOfArts: perfInfoData.nameOfArts, // Shared fields
  totalNoOfArtists: perfInfoData.totalNoOfArtists,
  existingProductions: perfInfoData.existingProductions,
  nameOfProductions: p.nameOfProductions, // From row
  briefOfPerformance: p.briefOfPerformance, // From row
  approxBudget: p.approxBudget, // From row
  sample: p.sample, // From row
})),
};
      // majorPerfCity: majorPerfCityIndia,
      // performanceInfo.majorPerfCities = cities.map((option) => option.map);

      // console.log(performanceFormData);

      const response = await makeAuthenticatedPATCHRequest(
        artistProfilePoints.UPDATE_PROFILE_DATA_API,
        { performanceInfo },
        accessToken
      );
      console.log("response ", response);
      if (response.status === "success") {
        toast.success("successfully updated ", {
          position: "top-center",
        });
        setActiveSection("award");
        localStorage.setItem("activeSection", activeSection);
      } else {
        toast.error(response.message, {
          position: "top-center",
        });
      }
    } catch (error) {
      console.log(error);
      toast.error("cannot updated successfully , please try again", {
        position: "top-center",
      });
    }

    toast.dismiss(toastId);
  };

  const [startDate, setStartDate] = useState(new Date());
  // ! for award profile
  const [awardFormData, setAwardFormData] = useState({
    totalAwards: "",
    totalNoOfLocalAwards: "",
    totalNoOfDistrictAwards: "",
    totalNoOfStateAwards: "",
    totalNoOfNationalAwards: "",
    totalNoOfInternationalAwards: "",
    awards: [],
  });

  // Professional Profile
  const [artProfile, setArtProfile] = useState({
    categoryOfArt: "",
    nameOfArt: "",
    typeOFArt: "",
    artEducation: "",
    professional: [],
    Traditional: [],
  });

  const awardChangeHandler = (event) => {
    const { name, value } = event.target;

    setAwardFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ! in this for awardd
  const handleInputChange = (index, field, value) => {
    const newAwards = [...awardFormData.awards];
    newAwards[index][field] = value;

    setAwardFormData({
      ...awardFormData,
      awards: newAwards,
    });
  };

  // Handle award document removal
  const handleRemoveAwardDocument = (rowIndex) => {
    const newAwardsTable = [...awardsTable];
    newAwardsTable[rowIndex].documentUrl = "";
    setAwardTable(newAwardsTable);
  };

  // ! award section update
  const awardSubmitsHandler = async (event) => {
    event.preventDefault();
    const taostId = toast.loading("Loding...");
    try {
      const {
        totalAwards,
        totalNoOfLocalAwards,
        totalNoOfDistrictAwards,
        totalNoOfStateAwards,
        totalNoOfNationalAwards,
        totalNoOfInternationalAwards,
        awards,
      } = awardFormData;

      let awardsInfo = {
        districtAwards: totalNoOfDistrictAwards,
        internationalAwards: totalNoOfInternationalAwards,
        localAwards: totalNoOfLocalAwards,
        nationalAwards: totalNoOfNationalAwards,
        stateAwards: totalNoOfStateAwards,
        totalAwards: totalAwards,
        awardsDetails: [...awards],
      };

      const response = await makeAuthenticatedPATCHRequest(
        artistProfilePoints.UPDATE_PROFILE_DATA_API,
        { awardsInfo },
        accessToken
      );
      // console.log("response", response);
      if (response.status === "success") {
        toast.success("successfully update", {
          position: "top-center",
        });

        localStorage.setItem("activeSection", activeSection);
      } else {
        toast.error(response.message, {
          position: "top-center",
        });
      }
    } catch (error) {
      console.log(error);
    }

    toast.dismiss(taostId);
  };

  // ! this is to add the new award in award section
  const addNewAward = () => {
    const newAward = {
      NameOfGuru: "",
      Location: "",
      Duration: "",
      year: "",
      Document: "",
    };
    setAwardFormData({
      ...awardFormData,
      awards: [...awardFormData.awards, newAward],
    });
  };

  // this is add button in Professional Art Education

  const addProfessional = () => {
    const filled = {
      NameOfGuru: "",
      Location: "",
      Duration: "",
      year: "",
      Document: "",
    };
    setArtProfile({
      ...artProfile,
      professional: [...artProfile.professional, filled],
    });
  };

  const addTraditional = () => {
    const newTradition = {
      Course: "",
      Specialisation: "",
      Institute: "",
      Duration: "",
      Completion: "",
      Document: "",
    };
    setArtProfile({
      ...artProfile,
      Traditional: [...artProfile.Traditional, newTradition],
    });
  };

  //remove the //remove the Professional
  const removeLastTradition = () => {
    const newTradition = [...artProfile.Traditional];
    newTradition.pop(); // Remove the last element

    setArtProfile({
      ...artProfile,
      Traditional: newTradition,
    });
  };

  const removeLastProfessional = () => {
    const filled = [...artProfile.professional];
    filled.pop(); // Remove the last element

    setArtProfile({
      ...artProfile,
      professional: filled,
    });
  };

  // ! remove the award detail in award section
  const removeLastAward = () => {
    const newAwards = [...awardFormData.awards];
    newAwards.pop(); // Remove the last element

    setAwardFormData({
      ...awardFormData,
      awards: newAwards,
    });
  };

  const [chikuData,setChikuData] = useState([])


  //  ! fetch  profile data function
 const fetchProileData = async () => {

  if(searchParams.get("section") === "product") setActiveSection("product");
  try {
    const response = await makeAuthenticatedGETRequest(
      `${artistProfilePoints.FETCH_PROFILE_DATA_API}/${localStorage.getItem("artId")}`,
      accessToken
    );
     
    console.log("=== PROFILE DATA DEBUG ===");
    console.log("Full API Response:", response.data);
    console.log("PersonalInfo Object:", response.data?.personalInfo);
    console.log("isVerified Key Present?", "isVerified" in (response.data?.personalInfo || {}));
    console.log("isVerified Value:", response.data?.personalInfo?.isVerified);
    console.log("isVerified Type:", typeof response.data?.personalInfo?.isVerified);
    console.log("========================");

    const {
      address,
      appliedOpportunities,
      artInfo,
      awardsInfo,
      certificateInfo,
      otherInfo,
      performanceInfo,
      personalInfo,
      professionalInfo,
      savedOpportunities,
      socialLinks,
      traditionalInfo,
    } = response.data;



     // ✅ CRITICAL: Set verification status properly
    const verificationStatus = personalInfo?.isVerified === true;
    console.log("Final Verification Status (boolean):", verificationStatus);
       setIsVerified(personalInfo?.isVerified || false);

    // Set profile avatar
    if (personalInfo?.avatar?.url) {
      setProfileAvatar(personalInfo?.avatar?.url);
    }

    // Set traditional table
    setChiku(traditionalInfo || []);

    // Set performance details table
    if (performanceInfo?.perfDetails && performanceInfo.perfDetails.length > 0) {
      setTableData(performanceInfo.perfDetails);
    }

    // ✅ FIX: Restore perfInfoData (uncomment and handle array/undefined)
    if (performanceInfo?.performances && performanceInfo.performances.length > 0) {
      const firstPerf = performanceInfo.performances[0]; // Or map if multiple
      setPerfInfoData((prev) => ({
        ...prev,
        nameOfArts: firstPerf.nameOfArts || "",
        totalNoOfArtists: firstPerf.totalNoOfArtists || 0,
        existingProductions: firstPerf.existingProductions || false,
        nameOfProductions: firstPerf.nameOfProductions || "",
        briefOfPerformance: firstPerf.briefOfPerformance || "",
        approxBudget: firstPerf.approxBudget || 0,
        sample: firstPerf.sample || firstPerf.samples || "", // Handle both keys
      }));
      // If multiple performances, set productions state (from previous suggestion)
      setProductions(performanceInfo.performances.map(p => ({
        nameOfProductions: p.nameOfProductions || "",
        briefOfPerformance: p.briefOfPerformance || "",
        approxBudget: p.approxBudget || 0,
        sample: p.sample || p.samples || "",
      })));
    } else {
      // Default if no data
      setPerfInfoData({
        nameOfArts: "",
        totalNoOfArtists: 0,
        existingProductions: false,
        nameOfProductions: "",
        briefOfPerformance: "",
        approxBudget: 0,
        sample: "",
      });
      setProductions([{ nameOfProductions: "", briefOfPerformance: "", approxBudget: 0, sample: "" }]);
    }

    // Set art info
    setArtInfoFormData((prev) => ({
      ...prev,
      aboutArt: artInfo?.aboutArt || "",
      artCategory: artInfo?.artCategory || [],
      artEducation: artInfo?.artEducation || "",
      artName: artInfo?.artName || [],
      artType: artInfo?.artType || [],
    }));
    setCategoryOption(artInfo?.artCategory?.map((item) => ({ value: item, label: item })) || []);
    setArtOption(artInfo?.artType?.map((item) => ({ value: item, label: item })) || []);
    setArtNameOption(artInfo?.artName?.map((item) => ({ value: item, label: item })) || []);

    // Set award data
    setAwardData((prev) => ({
      ...prev,
      highlights: awardsInfo?.highlights || "",
      level: awardsInfo?.level || "",
      totalAwards: awardsInfo?.totalAwards || "",
      awardsDetails: awardsInfo?.awardsDetails || [],
    }));
    if (awardsInfo?.awardsDetails?.length > 0) {
      setAwardTable(awardsInfo.awardsDetails);
    }

    // Set traditional and professional tables
    if (traditionalInfo?.length > 0) {
      setTraditionalTable(traditionalInfo);
    }
    if (professionalInfo?.length > 0) {
      setProfessionalTable(professionalInfo);
    }

    // Set basic form data
    setBasicFormData((prev) => ({
      ...prev,
      firstName: personalInfo?.firstName || "",
      lastName: personalInfo?.lastName || "",
      email: personalInfo?.email || "",
      age: personalInfo?.age || "",
      phoneNumber: personalInfo?.contactNumber?.number || "",
      countryCode: personalInfo?.contactNumber?.countryCode || "",
      gender: personalInfo?.gender || "",
      about: personalInfo?.about || "",
      monthlyIncome: personalInfo?.monthlyIncome || "",
      socialCategory: personalInfo?.socialCategory || "",
      customID: personalInfo?.customID || "",
      isVerified: personalInfo?.isVerified || false,
      pwd: personalInfo?.pwd || "",
      incomeSrc: personalInfo?.incomeSrc || "",
      aadharNumber: otherInfo?.aadharNumber || "",
      highestEducation: otherInfo?.highestEducation || "",
      panNumber: otherInfo?.panNumber || "",
      anunalIncomeByPerf: otherInfo?.anunalIncomeByPerf || "",
      yearOfCompletion: otherInfo?.yearOfCompletion || "",
      upiId: otherInfo?.upiId || "",
      gstIn: otherInfo?.gstIn || "",
      numOfperformanceLastYear: otherInfo?.lastYearPerfsCount || "",
      passportNumber: otherInfo?.passportNumber || "",
      languages: personalInfo?.languages || [],
      contactNumber: {
        ...prev.contactNumber,
        number: personalInfo?.contactNumber?.number || "",
        countryCode: personalInfo?.contactNumber?.countryCode || "",
      },
      address: {
        ...prev.address,
        ...address || { state: "", city: "", pincode: "", details: "" },
      },
      handles: {
        ...prev.handles,
        ...socialLinks || {},
      },
      idProof: {
        ...prev.idProof,
        ...otherInfo?.idProof || { name: "", num: "" },
      },
    }));

    setlanguagesoptions(personalInfo?.languages?.map((item) => ({ value: item, label: item })) || []);

    // Set art form data (similar fixes for defaults)
    setArtFormData((prev) => ({
      ...prev,
      natureOfArt: artInfo?.artCategory || "",
      areaOfInterest: artInfo?.areaOfInterest || "",
      traditionArtName: traditionalInfo?.[0]?.artName || "",
      artForm: artInfo?.artForm || "",
      performanceType: artInfo?.perfType || "",
      artEducation: artInfo?.learningSrc || "",
      artName: artInfo?.artName || "",
      nameOfGuru: traditionalInfo?.[0]?.guruName || "",
      yearOfCompletation: traditionalInfo?.[0]?.completionYear || "",
      certificateOfArt: traditionalInfo?.[0]?.certificate || "",
      academicQualification: professionalInfo?.[0]?.qualification || "",
      course: professionalInfo?.[0]?.course || "",
      specialization: professionalInfo?.[0]?.specialization || "",
      institute: professionalInfo?.[0]?.institute || "",
      certificateInstitute: certificateInfo?.institute || "",
      certificateCourse: certificateInfo?.course || "",
      artEduDuration: {
        ...prev.artEduDuration,
        start: traditionalInfo?.[0]?.duration?.start || "",
        end: traditionalInfo?.[0]?.duration?.end || "",
      },
      academicQualificationDuration: {
        ...prev.academicQualificationDuration,
        ...professionalInfo?.[0]?.duration || { start: "", end: "" },
      },
      certificateDuration: {
        ...prev.certificateDuration,
        ...certificateInfo?.duration || { start: "", end: "" },
      },
    }));

    // Set performance form data
    setPerformanceFormData((prev) => ({
      ...prev,
      experience: performanceInfo?.experience || "",
      typeOfPerformance: performanceInfo?.perfType || "",
      nameOfArtistGroupOrg: performanceInfo?.affiliation?.name || "",
      affiliatedToAnyGroup: performanceInfo?.affiliation?.isAffiliated || false,
      totalPerfs: performanceInfo?.totalPerfs || "",
      highestLevelOfPerformance: performanceInfo?.peakPerf || "",
      topFivePerformance: performanceInfo?.perfDetails || [],
      locationOfGroupOrg: performanceInfo?.affiliation?.location || "",
      contactNumber: performanceInfo?.affiliation?.contactNumber?.number || "",
      countryCode: performanceInfo?.affiliation?.contactNumber?.countryCode || "",
      avgPerfDurationIn: performanceInfo?.perfDuration?.india || "",
      avgPerfFeeIn: performanceInfo?.perfCharge?.india || "",
      avgPerfDurationInternational: performanceInfo?.perfDuration?.international || "",
      avgPerfFeeInternational: performanceInfo?.perfCharge?.international || "",
      majorPerfCityIndia: performanceInfo?.majorPerfCities || [],
      majorPerfCountryInternational: performanceInfo?.majorPerfCountry || "",
      aboutJourney: performanceInfo?.highlights || "",
      performanceImages: performanceInfo?.perfImgs || [],
      performancevideos: performanceInfo?.perfVideos || [],
    }));

    // Set cities from performance
    if (performanceInfo?.majorPerfCities && performanceInfo.majorPerfCities.length > 0) {
      setCities(performanceInfo.majorPerfCities.map((item) => ({ value: item, label: item })));
    } else {
      setCities([]);
    }

    // Set perf videos
    if (performanceInfo?.perfVideos && performanceInfo.perfVideos.length > 0) {
      const videoUrls = [
        performanceInfo.perfVideos[0] || '',
        performanceInfo.perfVideos[1] || '',
        performanceInfo.perfVideos[2] || ''
      ];
      setPerfVideo(videoUrls);
    }

    // Progress bar calculation (keep as is)
  } catch (error) {
    console.error("Fetch Profile Error:", error); // Debug log
    toast.error("Failed to load profile data. Please refresh and try again.");
  }
};

  // const handlePerformanceTableChange = (e, rowIdx, key) => {
  //   const newData = [...tableData];
  //   newData[rowIdx][key] = e.target.value;
  //   setTableData(newData);
  //   const file = e.target.files[0];
  //   const reader = new FileReader();

  //   reader.onload = (event) => {
  //     const updatedTableData = [...tableData];
  //     updatedTableData[rowIdx][key] = event.target.result;
  //     setTableData(updatedTableData);
  //   };

  //   reader.readAsDataURL(file);
  // };

  const handlePerformanceTableChange = (e, rowIdx, key) => {
  // Clone the existing tableData array to avoid mutating the state directly
  const newData = [...tableData];

  // Update the value of the specified cell in the cloned array
  newData[rowIdx][key] = e.target.value;

  // Set the state with the updated array
  setTableData(newData);

  // Check if the input is a file input
  if (e.target.type === 'file') {
    // If it's a file input, read the contents of the file
    const file = e.target.files[0];
    const reader = new FileReader();

    // Set up a callback for when the file reading is complete
    reader.onload = (event) => {
      // Clone the existing tableData array again
      const updatedTableData = [...tableData];
      // Update the value of the specified cell with the file content (e.g., base64 data)
      updatedTableData[rowIdx][key] = event.target.result;

      // Set the state with the tableData containing the updated file content
      setTableData(updatedTableData);
    };

    // Read the file as a data URL
    reader.readAsDataURL(file);
  }
};


  const handleAwardTable = (e, rowIdx, key) => {
    const newData = [...awardsTable];
    newData[rowIdx][key] = e.target.value;
    setAwardTable(newData);
  };

  useEffect(() => {
    fetchProileData();
  }, []);

  // ! this is to add avatar file
  // ! this is to add avatar file
  const handleButtonClick = () => {
    // const fileInput = document.createElement("input");
    // fileInput.type = "file";
    // fileInput.accept = ".jpg, .jpeg, .png";
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".jpg, .jpeg, .png";
    fileInput.onchange = handleFileChange;
    fileInput.click();
  };
  const [profileLoading, setProfileLoading] = useState(false);

  // ! this is to add the avatar
  // ! this is to add the avatar
  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];
    console.log(
      "🚀 ~ file: Artist_Profile.js:1444 ~ handleFileChange ~ selectedFile:",
      selectedFile
    );

    if (selectedFile) {
      // console.log("sele", selectedFile);
      let fileSizeKiloBytes = selectedFile.size / 1024;

      if (fileSizeKiloBytes >= 1024) {
        return toast.error("Image should be be less than 1mb");
      }
      const formData = new FormData();
      formData.append("avatar", selectedFile);

      setProfileLoading(true);
      const toastId = toast.loading("Updating");
      try {
        const response = await makeAuthenticated_Multi_Patch_REQ(
          artistProfilePoints.UPDATE_ARTIST_AVATAR_API,
          formData,
          accessToken
        );
        console.log("res", response);
        setProfileAvatar(response?.data?.avatar?.url);
        toast.dismiss(toastId);
        toast.success("Avatar Updated");
        setProfileLoading(false);
      } catch (error) {
        console.log(error);
        setProfileLoading(false);
        // toast.success(res)
      }
      // const response = await makeAuthenticated_Multi_Patch_REQ(
      //   artistProfilePoints.UPDATE_ARTIST_AVATAR_API,
      //   formData,
      //   accessToken
      // );
      // console.log("res", response);
      // setProfileAvatar(response?.data?.avatar);
    }
  };

  const [perfVideo, setPerfVideo] = useState(["", "", ""]);
  const handleInputChangeVideo = (index, value) => {
    const newInputValues = [...perfVideo];
    newInputValues[index] = value;
    setPerfVideo(newInputValues);
  };

  const handelMultipleImages = async (e) => {
  const Files = e.target.files;
  if (!Files || Files.length === 0) return;

  const newImages = Array.from(Files);

  // Limit number of images
  if (newImages.length > 6)
    return toast.error("You can upload up to 6 images only");

  // Check sizes
  let totalSizeKB = 0;
  let allBelow1MB = true;

  newImages.forEach((img) => {
    const sizeKB = img.size / 1024;
    if (sizeKB >= 1024) allBelow1MB = false;
    totalSizeKB += sizeKB;
  });

  if (!allBelow1MB || totalSizeKB >= 16384)
    return toast.error("Each image must be under 1 MB, total under 16 MB");

  // Local preview
  const localPreviews = newImages.map((file) => URL.createObjectURL(file));
  setPerformanceFormData((prev) => ({
    ...prev,
    localPerformanceImages: [
      ...(prev.localPerformanceImages || []),
      ...localPreviews,
    ],
  }));

  // Prepare FormData
  const formData = new FormData();
  newImages.forEach((img) => formData.append("images", img));

  const toastId = toast.loading("Uploading...");

  const fullUrl = `${process.env.EXPO_PUBLIC_BASE_URL}${artistProfilePoints.UPLOAD_PERF_IMAGES}`;
console.log("📌 Upload API URL ->", fullUrl);

  try {
    const response = await makeAuthenticated_Multi_Patch_REQ(
      artistProfilePoints.UPLOAD_PERF_IMAGES,
      formData,
      accessToken
    );

    toast.dismiss(toastId);
    console.log("Image Upload Response ->", response);

    if (response?.status === "error") {
      return toast.error("Upload failed");
    }

    // Normalize image URLs from backend
    const returned = response?.data?.performanceInfo?.perfImgs || [];

    const normalized = returned.map((img) => {
      if (!img) return img;
      // ✅ prevent double URL issue
      if (
        img.startsWith("http://") ||
        img.startsWith("https://") ||
        img.includes("uploads/performance")
      ) {
        return img;
      }
      return `https://api.ekalakaar.com/images/${img}`;
    });

    // Update form data
    setPerformanceFormData((prev) => ({
      ...prev,
      performanceImages: normalized,
    }));

    // Cleanup local blob URLs after successful upload
    localPreviews.forEach((url) => {
      try {
        URL.revokeObjectURL(url);
      } catch {}
    });

    toast.success("Performance Images Uploaded");
  } catch (error) {
    toast.dismiss(toastId);
    console.error("Image upload error:", error);
    toast.error(error?.message || "Upload failed");
  }
};


  // Handle performance image removal
const handleRemoveImage = async (index) => {
  try {
    const toastId = toast.loading("Removing image...");
    
    const updatedImages = performanceFormData.performanceImages.filter(
      (_, i) => i !== index
    );
    
    const response = await makeAuthenticatedPATCHRequest(
      artistProfilePoints.UPDATE_PROFILE_DATA_API,
      { 
        performanceInfo: {
          perfImgs: updatedImages
        }
      },
      accessToken
    );
    
    toast.dismiss(toastId);
    
    if (response.status === "success") {
      setPerformanceFormData({
        ...performanceFormData,
        performanceImages: updatedImages,
      });
      toast.success("Image removed successfully");
    } else {
      toast.error("Failed to remove image");
    }
  } catch (error) {
    toast.error("Failed to remove image");
    console.error("Remove Error:", error);
  }
};

  //! this is for remove avatart
  const handleRemoveAvatar = async (event) => {
    //! this is for remove avatart
      event.preventDefault();

      const response = await makeAuthenticatedDELETERequest(
        artistProfilePoints.UPDATE_ARTIST_AVATAR_API,
        accessToken
      );
      setProfileAvatar(null);
    };

  //   ! dont change this
  const mystyle = {
    fontSize: "large",
    fontWeight: "500",
  };
  const back = {
    backgroundColor: "transparent",
    marginLeft: "0vh",
    marginTop: "-2vh",
  };
  //   ! dont change this
  // const mystyle = {
  //   fontSize: "large",
  //   fontWeight: "500",
  // };
  // const back = {
  //   backgroundColor: "transparent",
  //   marginLeft: "0vh",
  //   marginTop: "-2vh",
  // };

  //Art Profile page

  const [artTable, setArtTable] = useState([
    {
      art: "",
      guru: "",
      Location: "",
      duration: "",
      completion: "",
      link: "",
    },
    {
      art: "",
      guru: "",
      Location: "",
      duration: "",
      completion: "",
      link: "",
    },
    {
      art: "",
      guru: "",
      Location: "",
      duration: "",
      completion: "",
      link: "",
    },
  ]);

  //new Award Page
  const [awardData, setAwardData] = useState({
    highlights: "",
    level: "",
    totalAwards: "",
    awardsDetails: [],
  });

  const handleTraditional = (e, rowIdx, key) => {
    const newData = [...traditionalTable];
    newData[rowIdx][key] = e.target.value;
    setTraditionalTable(newData);
  };

  const [professionalTable, setProfessionalTable] = useState([
    {
      course: "",
      specialization: "",
      institute: "",
      duration: "",
      completionYear: 0,
      // link: "",
    },
    {
      course: "",
      specialization: "",
      institute: "",
      duration: "",
      completionYear: 0,
      // link: "",
    },
    {
      course: "",
      specialization: "",
      institute: "",
      duration: "",
      completionYear: 0,
      // link: "",
    },
  ]);

  const [awardsTable, setAwardTable] = useState([
    {
      title: "",
      awardingBody: "",
      level: "",
      location: "",
      year: "",
      documentUrl: "",
    },
    {
      title: "",
      awardingBody: "",
      level: "",
      location: "",
      year: "",
      documentUrl: "",
    },
    {
      title: "",
      awardingBody: "",
      level: "",
      location: "",
      year: "",
      documentUrl: "",
    },
    {
      title: "",
      awardingBody: "",
      level: "",
      location: "",
      year: "",
      documentUrl: "",
    },
  ]);

  const awardHandle = (event) => {
    const { name, value } = event.target;

    setAwardData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  // console.log("Award",awardData);

  const awardSubmitHandler = async (event ,) => {
    event.preventDefault();
    const toastId = toast.loading("Loading...");
    try {
      let awardsInfo = {
        awardsDetails: awardsTable,
        level: awardData.level,
        highlights: awardData.highlights,
        totalAwards: awardData.totalAwards,
      };

      const response = await makeAuthenticatedPATCHRequest(
        artistProfilePoints.UPDATE_PROFILE_DATA_API,
        { awardsInfo },
        accessToken
      );
      // console.log("response ", response);
      if (response.status === "success") {
        toast.success("successfully updated ", {
          position: "top-center",
        });
        setActiveSection("award");
        localStorage.setItem("activeSection", activeSection);
      } else {
        toast.error(response.message, {
          position: "top-center",
        });
      }
    } catch (error) {
      console.log(error);
      toast.error("cannot updated successfully , please try again", {
        position: "top-center",
      });
    } finally {
      toast.dismiss(toastId);
    }
  };

  const awardTableHandle = (e, rowIdx, key) => {
    const newAwardsTable = [...awardsTable];
    newAwardsTable[rowIdx][key] = e.target.value;
    setAwardData(awardsTable);
  };

  // console.log("==>");
  // console.log("Check By Chiku => ",basicFormData.passportNumber);
  // console.log("==>");

  // console.log("award Page",awardData);
  const artNameHandler = (e) => {
    artNameOption.push({ value: artName, label: artName });
    const NewArtNameOption = artNameOption?.filter(
      (item) => item.value !== "Any Other"
    );
    setArtNameOption(NewArtNameOption);
    setArtName("");
  };

  const languageHandle = (e) => {
    languagesoptions.push({ value: anyLanguage, label: anyLanguage });
    const NewLanguageOption = languagesoptions?.filter(
      (item) => item.value !== "Any Other"
    );
    setlanguagesoptions(NewLanguageOption);
  };
  const multiSectionHandle = (e) => {
    const { name } = e.target;
    if (name === "Category") {
      categoryOption.push({ value: newCategory, label: newCategory });
      const NewCategoryOption = categoryOption.filter(
        (item) => item.value !== "Any Other"
      );
      setCategoryOption(NewCategoryOption);
      setNewCategory("");
    }
    if (name === "Type") {
      artOption.push({ value: artTypes, label: artTypes });
      const newTypeOption = artOption.filter(
        (item) => item.value !== "Any Other"
      );
      setArtOption(newTypeOption);
      setArtTypes("");
    }
  };

  const [togglePerfAfflication, settogglePerfAfflication] = useState(
    performanceFormData.affiliatedToAnyGroup
  );
  const tableStyles = `
  .table-container {
    width: 100%;
    overflow-x: auto;
  }

  .performance_table {
    width: 100%;
  }

  .performance_table th, .performance_table td {
    min-width: 150px;
    word-break: break-all;
  }

  @media (max-width: 768px) {
    .performance_table th, .performance_table td {
      min-width: auto;
    }
  }
`;

  const [showForms, setShowForms] = useState([true]);

  const toggleForm = () => {
    if (showForms.length < 4) {
      setShowForms([...showForms, true]);
    }
  };

  const removeForm = (indexToRemove) => {
    setShowForms(showForms.filter((_, index) => index !== indexToRemove));
  };
  useEffect(() => {
    const styleElement = document.createElement("style");
    styleElement.innerHTML = tableStyles;
    document.head.appendChild(styleElement);

    // Clean up the style element when the component unmounts
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);



  const artSubmitHandler = async (event) => {
    event.preventDefault();
    const toastId = toast.loading("Loading...");



    const {
      artEduDuration,
      artForm,
      // artName,
      performanceType,
      natureOfArt,
      // nameOfGuru,
      yearOfCompletation,
      traditionArtName,
      academicQualification,
      course,
      specialization,
      institute,
      academicQualificationDuration,
      certificateCourse,
      certificateInstitute,
      certificateDuration,
    } = artFormData;

    const { aboutArt, artCategory, artEducation, artName, artType } =
      artInfoFormData;


    let artInfo = {
      aboutArt: aboutArt,
      // artCategory: artCategory,
      artEducation: artEducation,
      artName: artName,
      // artType: artType,
      artCategory: categoryOption.map((option) => option.value),
      artEducation: artEducation,
      artName: artNameOption.map((option) => option.value),
      artType: artOption.map((option) => option.value),
    };
    artInfo.artCategory = categoryOption.map((option) => option.value);

    artInfo.artType = artOption.map((option) => option.value);
  const traditionalInfo = traditionalTable

    let professionalInfo = professionalTable;
 

    try {
      const response = await makeAuthenticatedPATCHRequest(
        artistProfilePoints.UPDATE_PROFILE_DATA_API,
        { artInfo, professionalInfo ,  traditionalInfo },
        accessToken
      );

      // console.log("artrespone", response);

      if (response.status === "success") {
        toast.success("Successfully Updated", {
          position: "top-center",
        });
        setActiveSection("performance");
        localStorage.setItem("activeSection", activeSection);
      } else {
        toast.error(response.message, {
          position: "top-center",
        });
      }
    } catch (error) {
      console.log(error);
      toast.error("Not Updated Successfully , Please try again", {
        position: "top-center",
      });
    }

    toast.dismiss(toastId);
  };

  


  console.log("==>");
    console.log("Check By Chikuu",chikuData[0]?.eventName);
    console.log("==>");



  const isFilled = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === "string" && value.trim() !== "") return true;
    if (typeof value === "number" && value !== 0) return true;
    if (Array.isArray(value) && value.length > 0) return true;
    if (typeof value === "boolean" && value === true) return true;
    return false;
  };

  const countFields = (obj) => {
    let total = 0;
    let filled = 0;
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = obj[key];
        if (typeof value === "object" && value !== null && !Array.isArray(value)) {
          const nestedCounts = countFields(value);
          total += nestedCounts.total;
          filled += nestedCounts.filled;
        } else {
          total++;
          if (isFilled(value)) filled++;
        }
      }
    }
    return { total, filled };
  };

  const handleChange = (e) => {
      const { name, value, type, checked } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };
  
    const handleNestedChange = (e, field) => {
      const { name, value } = e.target;
      setFormData(prev => ({
        ...prev,
        [field]: { ...prev[field], [name]: value }
      }));
    };
  
    const handleArrayChange = (e, field) => {
      const value = e.target.value.split(',').map(item => item.trim());
      setFormData(prev => ({ ...prev, [field]: value }));
    };
  
    const handleProductSubmit = async (e) => {
      e.preventDefault();
      console.log(formData)
      
      try{
        const response = await makeAuthenticatedPOSTRequest(
          productPoints.UPLOAD_PRODUCTS_API,
          formData,
          accessToken
        )
        if(response.statusCode === 200){
          toast.success('Product uploaded Successfully!')
          // console.log(response.data);
          navigate('/marketplace');

        }else{
          toast.error("Product could not be uploaded!");
        }
  
      }catch(err){
        toast.error(err)
      }

      console.log(formData);
    };

  useEffect(() => {
    const allData = {
      basicFormData,
      artInfoFormData,
      performanceFormData,
      awardData,
    };

    const { total, filled } = countFields(allData);
    const percentage = total > 0 ? Math.round((filled / total) * 100) : 0;
    const rotationValue = Math.min((percentage / 100) * 360, 360);
    // setCount(percentage);
    console.log(basicFormData)
    // setRotation(rotationValue);
  }, [basicFormData, artInfoFormData, performanceFormData, awardData]);

  // -------------------- FORM HANDLERS --------------------
 


  return (
    <>
      <Artist_navbar />
    

      <div className="dashboard-layout">
       <Sidebar className="profile-sidebar" />
        <div className="chiku-ProfileSection">
          <div className="profile-left">
            <div className="BasicProfile_AccSet">
              <button
                className={activeSection === "basic" ? "active" : ""}
                onClick={() => handleClick("basic")}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    id="Vector"
                    d="M10 0C11.3261 0 12.5979 0.526784 13.5355 1.46447C14.4732 2.40215 15 3.67392 15 5C15 6.32608 14.4732 7.59785 13.5355 8.53553C12.5979 9.47322 11.3261 10 10 10C8.67392 10 7.40215 9.47322 6.46447 8.53553C5.52678 7.59785 5 6.32608 5 5C5 3.67392 5.52678 2.40215 6.46447 1.46447C7.40215 0.526784 8.67392 0 10 0ZM10 20C10 20 20 20 20 17.5C20 14.5 15.125 11.25 10 11.25C4.875 11.25 0 14.5 0 17.5C0 20 10 20 10 20Z"
                    fill="black"
                  />
                </svg>{" "}
                Basic Profile
              </button>
              <button
                className={activeSection === "art" ? "active" : ""}
                onClick={() => handleClick("art")}
              >
                <IoMicOutline /> Art Profile
              </button>
              <button
                className={activeSection === "performance" ? "active" : ""}
                onClick={() => handleClick("performance")}
              >
                <img src={performance} /> Performance Profile
              </button>
              <button
                className={activeSection === "award" ? "active" : ""}
                onClick={() => handleClick("award")}
              >
                <img src={star} /> Award Profile
              </button>
              <button
                className={activeSection === "product" ? "active" : ""}
                onClick={() => handleClick("product")}
              >
                <FaShoppingCart /> Art Production Profile
              </button>
            </div>
            <div className="BasicProfile_avatar">
              {/* <img loading="lazy" src={(profileAvatar === undefined || profileAvatar === null) ?(`https://ui-avatars.com/api/?name=${basicFormData.firstName}+${basicFormData.lastName}`):(`https://api.ekalakaar.com/uploads/avatars/${profileAvatar}`)} /> */}
              <div
                className="profileImg"
                style={{
                  background: `conic-gradient(#AD2F3B ${rotation}deg, #d9d9d9 0deg)`,
                }}
              >
                {/* <img loading="lazy" src={defaultPic} /> */}
                <img
                  loading="lazy"
                  src={getFullImageUrl(profileAvatar || "")}
                  alt="Profile avatar"
                  onError={(e) => {
                    console.error("Avatar load failed:", e.target.src);
                    try {
                      // try fallback: construct from original value
                      const fallback = getFullImageUrl(profileAvatar || "");
                      if (fallback && fallback !== e.target.src) {
                        e.target.onerror = null;
                        e.target.src = fallback;
                        return;
                      }
                      // try decode %40 -> @ fallback
                      if (e.target.src.includes("%40")) {
                        e.target.onerror = null;
                        e.target.src = e.target.src.replace(/%40/g, "@");
                        return;
                      }
                    } catch (err) {
                      console.warn("avatar fallback error", err);
                    }
                    e.target.onerror = null;
                    e.target.src = "/default-avatar.png";
                  }}
                  style={{ width: 220, height: 220, objectFit: "cover", borderRadius: "50%" }}
                />

                <div
                  className="progressBar"
                  style={{
                    transform: `rotate(${rotation}deg)translate(0px , -115px)rotate(-${rotation}deg)`,
                  }}
                >
                  {count}%
                </div>
              </div>
              {/* <p
                style={{ fontWeight: "500", fontSize: "30px", marginTop: "15px" }}
              >
                {" "}
                {basicFormData.firstName.toUpperCase()}{" "}
                {basicFormData.lastName.toUpperCase()}(eK ID: 12334)
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="35"
                  height="35"
                  viewBox="0 0 50 50"
                  fill="none"
                >
                  <circle cx="25" cy="25" r="25" fill="#61C6FF" />
                  <path
                    d="M14 26.7143L19.4935 32.2791C19.885 32.6757 20.5252 32.6757 20.9168 32.2791L36 17"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
                <b></b>
              </p> */}

  <div style={{ marginTop: '15px', fontFamily: 'Poppins, sans-serif' }}>
    {/* Line 1: Name and Blue Tick */}
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <span style={{ fontWeight: 500, fontSize: '30px' }}>
        {basicFormData.firstName.toUpperCase()} {basicFormData.lastName.toUpperCase()}
      </span>

    {/* ✅ Blue tick shows only when isVerified is true */}
      {isVerified && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          viewBox="0 0 50 50"
          fill="none"
          title="Verified Artist"
        >
          <circle cx="25" cy="25" r="25" fill="#61C6FF" />
          <path
            d="M14 26.7143L19.4935 32.2791C19.885 32.6757 20.5252 32.6757 20.9168 32.2791L36 17"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      )}

  {/* 
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        viewBox="0 0 50 50"
        fill="none"
      >
        <circle cx="25" cy="25" r="25" fill="#61C6FF" />
        <path
          d="M14 26.7143L19.4935 32.2791C19.885 32.6757 20.5252 32.6757 20.9168 32.2791L36 17"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg> */}
    </div>

    {/* Line 2: eK ID */}
    <p style={{ fontWeight: 400, fontSize: '18px', color: '#555', margin: 0 }}>
      (eK ID: {basicFormData.customID})
    </p>
  </div>


  <div className="BasicProfile_avatar">
      <div className="avatar-buttons-container">
          <button  onClick={handleButtonClick} className="BasicProfile_editavatar">Upload/Edit Profile Picture</button>
          <button onClick={handleRemoveAvatar}  className="BasicProfile_removeavatar">Remove Avatar</button>
      </div>
  </div>



              {/* <button
                onClick={handleButtonClick}
                className="BasicProfile_editavatar"
              >
                Upload/Edit Profile Picture
                
              </button>
              <button onClick={handleRemoveAvatar} className="BasicProfile_removeavatar">Remove Avatar</button> */}
            </div>
          </div>

          {/* this is for basic  */}

          <div className="profile-right">
            {activeSection === "basic" && (
              <div
                style={{ fontFamily: "Poppins" }}
                className="BasicProfile_Infoform"
              >
                <form onSubmit={basicSubmitHandler}>
                  <h4>BASIC PROFILE</h4>
                  {/* //PERSONAL INFORMATIONAL */}
                  <div className="BasicProfile_PersonalINfo">
                    <div className="BasicProfile_inputfield">
                      <label htmlFor="firstName">
                        First Name <span className="red">*</span>
                      </label>
                      <input
                        onChange={changeHandler}
                        name="firstName"
                        value={basicFormData.firstName}
                        type="text"
                        pattern="[a-zA-Z]+"
                      ></input>
                    </div>
                    <div className="BasicProfile_inputfield">
                      <label htmlFor="lastName">
                        Last Name <span className="red">*</span>
                      </label>
                      <input
                        onChange={changeHandler}
                        value={basicFormData.lastName}
                        name="lastName"
                        type="text"
                        pattern="[a-zA-Z]+"
                      ></input>
                    </div>
                    <div className="BasicProfile_inputfield">
                      <label htmlFor="email">
                        Email Id <span className="red">*</span>
                      </label>
                      <input
                        onChange={changeHandler}
                        value={basicFormData.email}
                        name="email"
                        type="email"
                        readOnly
                        style={{ backgroundColor: " rgba(0, 0, 0, 0.15);" }}
                      />
                    </div>
                    {/* <div className="BasicProfile_inputfield">
                      <label htmlFor="phoneNumber">
                        Contact Number <span className="red">*</span>
                      </label>
                      <input
                        onChange={changeHandler}
                        name="phoneNumber"
                        value={basicFormData.phoneNumber}
                        placeholder="+91"
                        type="tel"
                      ></input>
                    </div> */}
                    <div className="BasicProfile_inputfield">
                      <label htmlFor="">
                        Contact Number <span className="red">*</span>
                      </label>
                      <div>
                      <select
    onChange={changeHandler}
    name="contactNumber.countryCode"
    value={basicFormData?.contactNumber?.countryCode || "+91"}
    style={{
      width: "21%",
      marginRight: "4px",
      paddingRight: "2px",
    }}
  >
    <option value="+91">+91</option>
  </select>
                        <input
                          name="contactNumber.number"
                          maxLength={10}
                          pattern="[0-9]{10}"
                          onChange={changeHandler}
                          value={basicFormData?.contactNumber?.number}
                          placeholder="1234567890"
                          style={{ width: "77%" }}
                          required
                        />
                      </div>
                    </div>
                    <div className="age_basics">
                      <div
                        className="BasicProfile_inputfield"
                        // style={{ width: "30%" }}
                      >
                        <label htmlFor="age">
                          Age <span className="red">*</span>
                        </label>
                        {/* <input
                        type="number"
                        name="age"
                        onChange={changeHandler}
                        value={basicFormData.age}
                        style={{ width: "100%" }}
                      ></input> */}

                        <select
                          name="age"
                          onChange={changeHandler}
                          value={basicFormData.age}
                          style={{ width: "100%" }}
                          required
                        >
                        {Array.from({ length: 100 - 17 }, (_, index) => (
                    <option key={index} value={index + 18}>
                      {index + 18}
                    </option>
                  ))}
                          <option value="100+">100+</option>
                        </select>
                      </div>

                      <div
                        className="BasicProfile_inputfield gender"
                        // style={{ width: "30%" }}
                      >
                        <label>
                          Gender <span className="red">*</span>
                        </label>
                        <div className="Genderinfo1">
                          <select
                            style={{
                              // width: "100%",
                              fontFamily: "Poppins",
                              background: "transparent",
                              color: "black",
                              height: "60px",
                            }}
                            onChange={changeHandler}
                            value={basicFormData.gender}
                            name="gender"
                          >
                            <option selected hidden>
                              Gender
                            </option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Transgender">Transgender</option>
                            <option value="Any Other">Any Other</option>
                            <option value="Prefer not to say">
                              Prefer not to say
                            </option>
                          </select>
                        </div>
                      </div>
                      <div
                        className="BasicProfile_inputfield"
                        // style={{ width: "30%" }}
                      >
                        <label>
                          Language Known <span className="red">*</span>
                        </label>
                        <Select
                          styles={{ overflowY: "auto", height: "50px" }}
                          defaultValue={languagesoptions}
                          value={languagesoptions}
                          isMulti
                          onChange={setlanguagesoptions}
                          options={languageOptions}
                        />
                      </div>
                      {languagesoptions?.find((e) => e.value === "Any Other") !==
                      undefined ? (
                        <>
                          <div className="BasicProfile_inputfield">
                            <label htmlFor="firstName">Enter Your Language</label>
                            <input
                              onChange={(e) => setAnyLanguage(e.target.value)}
                              name="firstName"
                              value={anyLanguage}
                              type="text"
                            ></input>
                            <button
                              name="Language"
                              onClick={multiSectionHandle}
                              style={{
                                background: "red",
                                marginTop: "10px",
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                border: "none",
                                fontSize: "25px",
                                color: "#fff",
                              }}
                            >
                              +
                            </button>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div>
                      {/* <div> */}
                      <h4>ADDRESS</h4>
                      <div className="BasicProfile_Address">
                        <div className="BasicProfile_Addressshort">
                          <div className="BasicProfile_inputfield">
                            <label>
                              Pincode <span className="red">*</span>
                            </label>
                            <input
                              maxLength={6}
                              pattern="[0-9]{6}"
                              onChange={changeHandler}
                              value={basicFormData.address.pincode}
                              name="address.pincode"
                              type="number"
                              style={{ width: "100%" }}
                              required
                            ></input>
                          </div>



                          <div className="BasicProfile_inputfield">
                            <label>State</label>
                            <select
                              onChange={changeHandler}
                              name="address.state"
                              value={basicFormData.address.state}
                              style={{ width: "100%" }}
                            >
                              <option selected hidden>
                                Select State
                              </option>
                              <option value="Andhra Pradesh">
                                Andhra Pradesh
                              </option>
                              <option value="Andaman and Nicobar Islands">
                                Andaman and Nicobar Islands
                              </option>
                              <option value="Arunachal Pradesh">
                                Arunachal Pradesh
                              </option>
                              <option value="Assam">Assam</option>
                              <option value="Bihar">Bihar</option>
                              <option value="Chandigarh">Chandigarh</option>
                              <option value="Chhattisgarh">Chhattisgarh</option>
                              <option value="Dadar and Nagar Haveli">
                                Dadar and Nagar Haveli
                              </option>
                              <option value="Daman and Diu">Daman and Diu</option>
                              <option value="Delhi">Delhi</option>
                              <option value="Lakshadweep">Lakshadweep</option>
                              <option value="Puducherry">Puducherry</option>
                              <option value="Goa">Goa</option>
                              <option value="Gujarat">Gujarat</option>
                              <option value="Haryana">Haryana</option>
                              <option value="Himachal Pradesh">
                                Himachal Pradesh
                              </option>
                              <option value="Jammu and Kashmir">
                                Jammu and Kashmir
                              </option>
                              <option value="Jharkhand">Jharkhand</option>
                              <option value="Karnataka">Karnataka</option>
                              <option value="Kerala">Kerala</option>
                              <option value="Madhya Pradesh">
                                Madhya Pradesh
                              </option>
                              <option value="Maharashtra">Maharashtra</option>
                              <option value="Manipur">Manipur</option>
                              <option value="Meghalaya">Meghalaya</option>
                              <option value="Mizoram">Mizoram</option>
                              <option value="Nagaland">Nagaland</option>
                              <option value="Odisha">Odisha</option>
                              <option value="Punjab">Punjab</option>
                              <option value="Rajasthan">Rajasthan</option>
                              <option value="Sikkim">Sikkim</option>
                              <option value="Tamil Nadu">Tamil Nadu</option>
                              <option value="Telangana">Telangana</option>
                              <option value="Tripura">Tripura</option>
                              <option value="Uttar Pradesh">Uttar Pradesh</option>
                              <option value="Uttarakhand">Uttarakhand</option>
                              <option value="West Bengal">West Bengal</option>
                            </select>
                          </div>
                          <div className="BasicProfile_inputfield">
                            <label>City</label>
                            <input
                              onChange={changeHandler}
                              name="address.city"
                              value={basicFormData.address.city}
                              type="text"
                              style={{ width: "100%" }}
                            ></input>
                          </div>
                        </div>

                        {/* <div className="BasicProfile_inputfield BasicProfile_Addresslong">
                  <label>Detailed Address</label>
                  <textarea style={{width:"100%" , height:"150px" , resize:"none" , borderRadius:"10px" , padding:"10px"}} onChange={changeHandler} name="address.details" value={basicFormData.address.details} type="text" />
                </div> */}
                      </div>
                      {/* </div> */}
                      {/* </div> */}

                      <div className="BasicProfile_OtherDetails">
                        {/* <div className="BasicProfile_inputfield">
                  <label>No of Performance Last Year</label>
                  <input onChange={changeHandler} name="numOfperformanceLastYear" placeholder="Enter no of performance" value={basicFormData.numOfperformanceLastYear} type="text"></input>
                </div> */}
                        <div className="BasicProfile_inputfield">
                          <label>Highest Education Qualification </label>
                          <select
                            onChange={changeHandler}
                            name="highestEducation"
                            value={basicFormData.highestEducation}
                          >
                            <option selected hidden>
                              Select
                            </option>
                            <option value="Illterate">Illterate</option>
                            <option value="Below Class 10">Below Class 10</option>
                            <option value="10th Pass">10th Pass </option>
                            <option value="Under Graduate">Under Graduate</option>
                            <option value="Graduation">Graduation</option>
                            <option value="Post Gradute">Post Graduate</option>
                            <option value="phd">PhD </option>
                            <option value="Professional Education">
                              Professional Education{" "}
                            </option>
                            <option value="Any Other">Any Other </option>
                          </select>
                        </div>
                        <div className="BasicProfile_inputfield">
                          <label>Year of Completion</label>
                          <select
                            onChange={changeHandler}
                            name="yearOfCompletion"
                            value={basicFormData.yearOfCompletion}
                          >
                            <option selected hidden>
                              Select
                            </option>
                            {years.map((item) => {
                              return <option value={item}>{item}</option>;
                            })}
                          </select>
                        </div>
                        <div className="BasicProfile_inputfield">
                          <label>Social Category </label>
                          <select
                            onChange={changeHandler}
                            name="socialCategory"
                            value={basicFormData.socialCategory}
                          >
                            <option selected hidden>
                              Select socialCategory
                            </option>
                            <option value="General">General</option>
                            <option value="OBC">
                              OBC (Other Backward Classes)
                            </option>
                            <option value="SC">SC (Scheduled Caste)</option>
                            <option value="ST">ST (Scheduled Tribe)</option>
                            <option value="Any Other">Any Other</option>
                          </select>
                        </div>
                        <div className="BasicProfile_inputfield">
                          <label>Person With Disability (PwD)</label>
                          <select
                            onChange={changeHandler}
                            name="pwd"
                            value={basicFormData.pwd}
                          >
                            <option selected hidden>
                              Select
                            </option>
                            <option value="No">No</option>
                            {disabilitiesArray.map((option) => (
                              <option value={option}>{option}</option>
                            ))}
                          </select>{" "}
                        </div>
                        <div className="BasicProfile_inputfield">
                          <label>Primary Source Of Income</label>
                          <select
                            onChange={changeHandler}
                            name="incomeSrc"
                            value={basicFormData.incomeSrc}
                          >
                            <option selected hidden>
                              Select income Source
                            </option>
                            {categories.map((option) => (
                              <option value={option}>{option}</option>
                            ))}
                          </select>
                        </div>

                        <div className="BasicProfile_inputfield">
                          <label>Annual Income from Performing Art (INR)</label>
                          <select
                            onChange={changeHandler}
                            name="anunalIncomeByPerf"
                            value={basicFormData.anunalIncomeByPerf}
                          >
                            <option selected hidden>
                              Select Income
                            </option>
                            <option value="<5000">Below Rs 5,000</option>
                            <option value="5000-10000">
                              Rs 5,000 - Rs 10,000
                            </option>
                            <option value="10000-20000">
                              Rs 10,000 - Rs 20,000
                            </option>
                            <option value="20000-50000">
                              Rs 20,000 - Rs 50,000
                            </option>
                            <option value="50000-100000">
                              Rs 50,000 - Rs 100,000
                            </option>
                            <option value="100000-250000">
                              Rs 100,000 - Rs 250,000
                            </option>
                            <option value="250000-500000">
                              Rs 250,000 - Rs 500,000
                            </option>
                            <option value=">500000">Above Rs 500,000</option>
                          </select>
                        </div>

                        <div className="BasicProfile_inputfield">
                          <label>Identity Proof</label>
                          <select
                            onChange={changeHandler}
                            name="idProof.name"
                            value={basicFormData.idProof.name}
                          >
                            {documentList.map((e) => (
                              <option value={e}>{e}</option>
                            ))}
                          </select>
                        </div>
                        <div className="BasicProfile_inputfield">
                          <label>ID Proof No</label>
                          <input
                            onChange={changeHandler}
                            value={basicFormData.idProof.num}
                            placeholder="Enter Id Num"
                            name="idProof.num"
                            type="text"
                          />
                        </div>
                        <div className="BasicProfile_inputfield">
                          <label>Pan Card</label>
                          <input
                            onChange={changeHandler}
                            value={basicFormData.panNumber}
                            placeholder="Enter Pan Number"
                            name="panNumber"
                            type="text"
                          />
                        </div>

                        <div
                          className="BasicProfile_inputfield"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label>Valid Passport</label>
                          <DatePicker
                            className="date_picker"
                            id="date"
                            name="Date"
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                          />{" "}
                        </div>
                        <div className="BasicProfile_inputfield">
                          <label>UPI Id (Optional)</label>
                          <input
                            onChange={changeHandler}
                            value={basicFormData.upiId}
                            placeholder="Enter UPI Id"
                            name="upiId"
                            type="text"
                          />
                        </div>
                      
                        <div className="BasicProfile_inputfield">
                          <label>GST IN</label>
                          <input
                            onChange={changeHandler}
                            value={basicFormData.gstIn}
                            placeholder="Enter GST IN"
                            name="gstIn"
                            type="text"
                          />
                        </div>
                      
                      </div>
                    </div>
                  </div>
                  <div>
                    <h4>SOCIAL MEDIA</h4>
                    <div className="BasicProfile_Social">
                      <div className="BasicProfile_inputfield">
                        <label>Instagram</label>
                        <input
                          onChange={changeHandler}
                          value={basicFormData?.handles?.instagram}
                          name="handles.instagram"
                          type="text"
                        ></input>
                        <img src={Instagram} alt="Instagram" />
                      </div>
                      <div className="BasicProfile_inputfield">
                        <label>Facebook</label>
                        <input
                          onChange={changeHandler}
                          value={basicFormData?.handles?.facebook}
                          name="handles.facebook"
                          type="text"
                        ></input>
                        <img src={Facebook} alt="Facebook" />
                      </div>
                      <div className="BasicProfile_inputfield">
                        <label>Youtube</label>
                        <input
                          onChange={changeHandler}
                          value={basicFormData?.handles?.youtube}
                          name="handles.youtube"
                          type="text"
                        ></input>
                        <img src={YouTube} alt="Youtube" />
                      </div>
                      <div className="BasicProfile_inputfield">
                        <label>LinkedIn</label>
                        <input
                          onChange={changeHandler}
                          value={basicFormData?.handles?.linkedIn}
                          name="handles.linkedIn"
                          type="text"
                        ></input>
                        <img src={LinkedIn} alt="LinkedIn" />
                      </div>
                      <div className="BasicProfile_inputfield">
                        <label>Website</label>
                        <input
                          onChange={changeHandler}
                          value={basicFormData?.handles?.website}
                          name="handles.website"
                          type="text"
                        ></input>
                        <img src={Globe} alt="Globe" />
                      </div>
                      <div className="BasicProfile_inputfield">
                        <label>X</label>
                        <input
                          onChange={changeHandler}
                          value={basicFormData?.handles?.twitter}
                          name="handles.twitter"
                          type="text"
                        ></input>
                        <img src={TwitterX} alt="TwitterX" />
                      </div>
                    </div>

                    <div style={{ width: "100%", marginTop: "20px" }}>
                      <label htmlFor="about">About My Journey</label>
                      <textarea
                        name="about"
                        value={basicFormData.about}
                        onChange={changeHandler}
                        style={{
                          width: "100%",
                          border: "2px solid rgb(0,0,0,0.5)",
                          padding: "10px",
                          borderRadius: "10px",
                          resize: "none",
                          height: "166px",
                        }}
                      />
                    </div>
                  </div>
                  <button type="submit" className="updateBtn">
                    Update
                  </button>
                </form>
              </div>
            )}

            {/* this is for art profile */}
            {activeSection === "art" && (
              <div
                style={{ fontFamily: "Poppins" }}
                className="ArtProfile_Infoform"
              >
                <form onSubmit={artSubmitHandler}>
                  <h4>ART PROFILE</h4>
                  <div className="ArtProfile_ArtInfo">
                    <div className="ArtProfile_inputfield">
                      <label>
                        Category of Art <span className="red">*</span>
                      </label>
                      <Select
                        defaultValue={categoryOption}
                        value={categoryOption}
                        isMulti
                        onChange={setCategoryOption}
                        options={categoryOfArt}
                      />
                    </div>

                    <div className="ArtProfile_inputfield">
                      <label>
                        Name Of Art <span className="red">*</span>
                      </label>
                      <Select
                        defaultValue={artNameOption}
                        value={artNameOption}
                        isMulti
                        onChange={setArtNameOption}
                        options={nameOfArt}
                      />
                    </div>
                    {artNameOption.find((e) => e.value === "Any Other") !==
                    undefined ? (
                      <>
                        <div className="BasicProfile_inputfield">
                          <label htmlFor="firstName"> Enter Name Of Art </label>
                          <input
                            onChange={(e) => setArtName(e.target.value)}
                            name="firstName"
                            value={artName}
                            type="text"
                          ></input>
                          <button
                            name="Art"
                            onClick={artNameHandler}
                            style={{
                              background: "red",
                              marginTop: "10px",
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              border: "none",
                              fontSize: "25px",
                              color: "#fff",
                            }}
                          >
                            +
                          </button>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    <div className="ArtProfile_inputfield">
                      <label>Type of Art</label>
                    
                      <Select
                        defaultValue={artOption}
                        value={artOption}
                        isMulti
                        onChange={setArtOption}
                        options={typeOfArts}
                      />
                    </div>
                    {artOption.find((e) => e.value === "Any Other") !==
                    undefined ? (
                      <>
                        <div className="BasicProfile_inputfield">
                          <label htmlFor="firstName">Enter Type Of Art </label>
                          <input
                            onChange={(e) => setArtTypes(e.target.value)}
                            value={artTypes}
                            type="text"
                          ></input>
                          <button
                            name="Type"
                            onClick={multiSectionHandle}
                            style={{
                              background: "red",
                              marginTop: "10px",
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              border: "none",
                              fontSize: "25px",
                              color: "#fff",
                            }}
                          >
                            +
                          </button>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    <div className="ArtProfile_inputfield">
                      <label>Art Education</label>
                      <select
                        onChange={artChangesHandler}
                        name="artEducation"
                        placeholder="Select name of the art "
                        value={artInfoFormData.artEducation}
                      >
                        <option value={""} disabled>
                          Select performance type
                        </option>
                        {performancetype.map((option, index) => (
                          <option key={index} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    </div>

                  
                  </div>
                  {artInfoFormData.artEducation === "Both" ||
                  artInfoFormData.artEducation === "Traditional" ? (
                    <>
                    


  {/* sharad table code */}
  <div className="award_plus_icon" onClick={toggleForm}>
  <h4>Traditional Art Education  </h4>
                      <div className="add-icon mobile">+</div>
                    </div>

                  <div className="award_table desktop">
                      <table className="performance_table">
                        <thead>
                          <tr>
                              <th> Name of Art </th>
                              <th> Name of Guru</th>
                              <th> Location (City/District)</th>
                              <th> Duration (Months)</th>
                              <th> Year of Completion </th>
                          </tr>
                        </thead>
                        <tbody>
                        {traditionalTable.map((row, rowIndex) => (
                              <tr key={rowIndex}>
                                {/* Yahan change kiya hai: .filter lagaya hai taaki documentUrl wala column na aaye */}
                                {Object.keys(row).filter(key => key !== 'documentUrl').map((key, colIndex) => (
                                  <td key={colIndex}>
                                    
                                    {(key === "artName" || key === "guruName") && (
                                      <input
                                        type="text"
                                        value={row[key]}
                                        defaultValue={awardData.highlight}
                                        onChange={(e) =>
                                          handleTraditional(e, rowIndex, key)
                                        }
                                      />
                                    )}
                                    {key === "location" && (
                                      <select
                                        style={{
                                          maxWidth: "150px",
                                          border: "none",
                                          padding: 0,
                                        }}
                                        type="text"
                                        value={row[key]}
                                        onChange={(e) =>
                                          handleTraditional(e, rowIndex, key)
                                        }
                                      >
                                        <option selected hidden>
                                          Select
                                        </option>
                                        {indian_states.map((item, index) => (
                                          <option key={index} value={item}>
                                            {item}
                                          </option>
                                        ))}
                                      </select>
                                    )}
                                    {key === "completionYear" && (
                                      <select
                                        style={{
                                          maxWidth: "150px",
                                          border: "none",
                                          padding: 0,
                                        }}
                                        defaultValue={chiku[rowIndex]?.completionYear}

                                        type="text"
                                        onChange={(e) =>
                                          handleTraditional(e, rowIndex, key)
                                        }
                                      >
                                        <option selected hidden>
                                          Select
                                        </option>
                                        {years.map((item) => (
                                          <option key={item} value={item}>
                                            {item}
                                          </option>
                                        ))}
                                      </select>
                                    )}
                                    {key === "duration" && (
                                      <select
                                        style={{
                                          maxWidth: "150px",
                                          border: "none",
                                          padding: 0,
                                        }}
                                        type="text"
                                      defaultValue={chiku[rowIndex]?.duration}

                                        onChange={(e) => {
                                          handleTraditional(e, rowIndex, key);
                                        }}
                                      >
                                        <option selected hidden>
                                          Select
                                        </option>
                                        {months.map((item) => (
                                          <option key={item} value={item}>
                                            {item}
                                          </option>
                                        ))}
                                      </select>
                                    )}
                                  </td>
                                ))}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>


                    {showForms.map((showForm, index) => (
                      <div
                        key={index}
                        className={`award_form mobile ${
                          showForm ? "show" : "hide"
                        }`}
                      >
                      {/*sharad mobile table */}
                        <div className="BasicProfile_inputfield">
                          <label htmlFor="Name of The Award">
                          Name of Course
                          </label>
                          <input type="text" pattern="[a-zA-Z]+" />
                        </div>
                        <div className="BasicProfile_inputfield">
                          <label htmlFor="Awarding Body">Specialisation</label>
                          <input type="text" pattern="[a-zA-Z]+" />
                        </div>
                        <div className="BasicProfile_inputfield">
                          <label>Name of Institute</label>
                          <input type="text" pattern="[a-zA-Z]+" />
                        </div>
                        <div className="BasicProfile_inputfield">
                          <label>Duration (Months)</label>
                          <select name="location">
                            <option selected hidden>
                              Select
                            </option>
                          </select>
                        </div>
                        <div className="BasicProfile_inputfield">
                          <label>Year of Completion </label>
                          <select name="year">
                            <option selected hidden>
                              Select
                            </option>
                          </select>
                        </div>
                        <div className="BasicProfile_inputfield">
                          <label>Upload Document</label>
                          <input
                            style={{ display: "none" }}
                            onChange={() => {}}
                            id="fileID"
                            placeholder="Enter UPI Id"
                            name="upiId"
                            type="file"
                          />
                          <div className="input">
                            <label id="upload" htmlFor="fileID">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M16 6V17.5C16 19.71 14.21 21.5 12 21.5C9.79 21.5 8 19.71 8 17.5L8 5C8 3.62 9.12 2.5 10.5 2.5C11.88 2.5 13 3.62 13 5V15.5C13 16.05 12.55 16.5 12 16.5C11.45 16.5 11 16.05 11 15.5V6H9.5V15.5C9.5 16.88 10.62 18 12 18C13.38 18 14.5 16.88 14.5 15.5L14.5 5C14.5 2.79 12.71 1 10.5 1C8.29 1 6.5 2.79 6.5 5L6.5 17.5C6.5 20.54 8.96 23 12 23C15.04 23 17.5 20.54 17.5 17.5V6H16Z"
                                  fill="black"
                                  fillOpacity="0.54"
                                />
                              </svg>
                            </label>
                          </div>
                        </div>
                        {showForms.length > 1 && (
                          <div className="another_mobile_div">
                            Traditional Art Education Another input
                            <div
                              className="remove-icon mobile"
                              onClick={() => removeForm(index)}
                            >
                              -
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  
                    </>
                  ) : (
                    ""
                  )}

                  <div className="ArtProfile_Traditional">
                    {artInfoFormData.artEducation === "Both" ||
                    artInfoFormData.artEducation === "Professional" ? (
                      <>
                      


                              {/* sharad table code */}
                    <div className="award_plus_icon" onClick={toggleForm}>
                        <h4>Professional Art Education </h4>
                      <div className="add-icon mobile">+</div>
                    </div>


                  <div className="award_table desktop">
                      <table className="performance_table">
                        <thead>
                          <tr>
                          <th> Name of Course</th>
                                <th> Specialisation</th>
                                <th> Name of Institute</th>
                                <th> Duration (Months)</th>
                                <th> Year of Completion </th>
                              
                          </tr>
                        </thead>
                        <tbody>
                        {professionalTable.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  {/* Yahan change kiya hai: .filter lagaya hai */}
                                  {Object.keys(row).filter(key => key !== 'documentUrl').map((key, colIndex) => (
                                    <td key={colIndex}>
                                    
                                      {(key == "course" ||
                                        key == "institute" ||
                                        key == "specialization") && (
                                        <input
                                          type="text"
                                          value={row[key]}
                                          defaultValue={awardData.highlight}
                                          onChange={(e) =>
                                            handleArtProfileChanges(
                                              e,
                                              rowIndex,
                                              key
                                            )
                                          }
                                        />
                                      )}

                                      {key == "completionYear" && (
                                        <select
                                          style={{
                                            maxWidth: "150px",
                                            border: "none",
                                            padding: 0,
                                          }}
                                          type="text"
                                          value={row[key]}
                                          defaultValue={awardData.highlight}
                                          onChange={(e) =>
                                            handleArtProfileChanges(
                                              e,
                                              rowIndex,
                                              key
                                            )
                                          }
                                        >
                                          <option selected hidden>
                                            Select
                                          </option>
                                          {years.map((item) => (
                                            <option key={item} value={item}>
                                              {item}
                                            </option>
                                          ))}
                                        </select>
                                      )}
                                      {key == "duration" && (
                                        <select
                                          style={{
                                            maxWidth: "150px",
                                            border: "none",
                                            padding: 0,
                                          }}
                                          type="text"
                                          value={row[key]}
                                          defaultValue={awardData.highlight}
                                          onChange={(e) =>
                                            handleArtProfileChanges(
                                              e,
                                              rowIndex,
                                              key
                                            )
                                          }
                                        >
                                          <option selected hidden>
                                            Select
                                          </option>
                                          {months.map((item) => (
                                            <option key={item} value={item}>
                                              {item}
                                            </option>
                                          ))}
                                        </select>
                                      )}
                                    </td>
                                  ))
                                  }
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    </div>





                    {showForms.map((showForm, index) => (
                      <div
                        key={index}
                        className={`award_form mobile ${
                          showForm ? "show" : "hide"
                        }`}
                      >
                      {/*sharad mobile table */}
                        <div className="BasicProfile_inputfield">
                          <label htmlFor="Name of The Award">
                          Name of Art
                          </label>
                          <input type="text" pattern="[a-zA-Z]+" />
                        </div>
                        <div className="BasicProfile_inputfield">
                          <label htmlFor="Awarding Body">Name of Guru</label>
                          <input type="text" pattern="[a-zA-Z]+" />
                        </div>
                        <div className="BasicProfile_inputfield">
                          <label>Location (City/District)</label>
                          <select name="level">
                            <option selected hidden>
                              Select
                            </option>
                          </select>
                        </div>
                        <div className="BasicProfile_inputfield">
                          <label>Duration (Months)</label>
                          <select name="location">
                            <option selected hidden>
                              Select
                            </option>
                          </select>
                        </div>
                        <div className="BasicProfile_inputfield">
                          <label>Year of Completion </label>
                          <select name="year">
                            <option selected hidden>
                              Select
                            </option>
                          </select>
                        </div>
                        <div className="BasicProfile_inputfield">
                          <label>Upload Document</label>
                          <input
                            style={{ display: "none" }}
                            onChange={() => {}}
                            id="fileID"
                            placeholder="Enter UPI Id"
                            name="upiId"
                            type="file"
                          />
                          <div className="input">
                            <label id="upload" htmlFor="fileID">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M16 6V17.5C16 19.71 14.21 21.5 12 21.5C9.79 21.5 8 19.71 8 17.5L8 5C8 3.62 9.12 2.5 10.5 2.5C11.88 2.5 13 3.62 13 5V15.5C13 16.05 12.55 16.5 12 16.5C11.45 16.5 11 16.05 11 15.5V6H9.5V15.5C9.5 16.88 10.62 18 12 18C13.38 18 14.5 16.88 14.5 15.5L14.5 5C14.5 2.79 12.71 1 10.5 1C8.29 1 6.5 2.79 6.5 5L6.5 17.5C6.5 20.54 8.96 23 12 23C15.04 23 17.5 20.54 17.5 17.5V6H16Z"
                                  fill="black"
                                  fillOpacity="0.54"
                                />
                              </svg>
                            </label>
                          </div>
                        </div>
                        {showForms.length > 1 && (
                          <div className="another_mobile_div">
                            Professional Art Education Another input
                            <div
                              className="remove-icon mobile"
                              onClick={() => removeForm(index)}
                            >
                              -
                            </div>
                          </div>
                        )}
                      </div>
                    ))}


                      </>
                    ) : (
                      ""
                    )}
                  </div>
                  <div style={{ width: "100%", marginTop: "20px" }}>
                    <label htmlFor="aboutArt">About The Art</label>
                    <textarea
                      name="aboutArt"
                      onChange={artChangesHandler}
                      value={artInfoFormData.aboutArt}
                      style={{
                        width: "100%",
                        border: "2px solid rgb(0,0,0,0.5)",
                        padding: "10px",
                        borderRadius: "10px",
                        resize: "none",
                        height: "166px",
                      }}
                    />
                  </div>

                  {artProfile.professional.map((professional, index) => (
                    <React.Fragment key={index}>
                      <h4>Professional Art Education +</h4>

                      {index === artProfile.professional.length - 1 ? (
                        // last index => add plus button
                        <>
                          <div className="AwardProfile_Awarddetials">
                            <div className="AwardProfile_inputfield">
                              <label>Name of Guru</label>
                              <input
                                value={professional.NameOfGuru}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "title",
                                    e.target.value
                                  )
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="AwardProfile_inputfield">
                              <label>Location</label>
                              <input
                                value={professional.Location}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "Location",
                                    e.target.value
                                  )
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="AwardProfile_inputfield">
                              <label>Duration (Month)</label>
                              <select
                                value={professional.Duration}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "category",
                                    e.target.value
                                  )
                                }
                              >
                                <option selected hidden>
                                  Select Art
                                </option>
                                <option>1</option>
                              </select>
                            </div>
                            {/* <div className="AwardProfile_inputfield">
                          <label>Name of the Stage</label>
                          <input value={award.stage} onChange={(e) => handleInputChange(index, "stage", e.target.value)} type="text"></input>
                        </div> */}
                            <div className="AwardProfile_inputfield">
                              <label>Year of Completion</label>
                              <input
                                value={professional.year}
                                onChange={(e) =>
                                  handleInputChange(index, "year", e.target.value)
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="BasicProfile_inputfield">
                              <label>Upload Document</label>
                              <input
                                value={professional.Document}
                                style={{ display: "none" }}
                                onChange={changeHandler}
                                id="fileID"
                                placeholder="Enter UPI Id"
                                name="upiId"
                                type="file"
                              />
                              <div className="input">
                                <label id="upload" htmlFor="fileID">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <path
                                      d="M16 6V17.5C16 19.71 14.21 21.5 12 21.5C9.79 21.5 8 19.71 8 17.5L8 5C8 3.62 9.12 2.5 10.5 2.5C11.88 2.5 13 3.62 13 5V15.5C13 16.05 12.55 16.5 12 16.5C11.45 16.5 11 16.05 11 15.5V6H9.5V15.5C9.5 16.88 10.62 18 12 18C13.38 18 14.5 16.88 14.5 15.5L14.5 5C14.5 2.79 12.71 1 10.5 1C8.29 1 6.5 2.79 6.5 5L6.5 17.5C6.5 20.54 8.96 23 12 23C15.04 23 17.5 20.54 17.5 17.5V6H16Z"
                                      fill="black"
                                      fill-opacity="0.54"
                                    />
                                  </svg>
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="AwardProfile_Addmorebtn">
                            <p>Add More Awards Details</p>
                            <button type="button">
                              {" "}
                              <svg
                                onClick={addProfessional}
                                xmlns="http://www.w3.org/2000/svg"
                                width="40"
                                height="40"
                                viewBox="0 0 40 40"
                                fill="none"
                              >
                                <circle cx="20" cy="20" r="20" fill="#AD2F3B" />
                                <text
                                  x="50%"
                                  y="50%"
                                  text-anchor="middle"
                                  fill="white"
                                  font-size="24px"
                                  font-family="Arial"
                                  dy=".3em"
                                >
                                  +
                                </text>
                              </svg>
                            </button>
                          </div>
                        </>
                      ) : (
                        // not last index => add - button
                        <>
                          <div className="AwardProfile_Awarddetials">
                            <div className="AwardProfile_inputfield">
                              <label>Name of Guru</label>
                              <input
                                value={professional.NameOfGuru}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "title",
                                    e.target.value
                                  )
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="AwardProfile_inputfield">
                              <label>Location</label>
                              <input
                                value={professional.Location}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "Location",
                                    e.target.value
                                  )
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="AwardProfile_inputfield">
                              <label>Duration (Month)</label>
                              <select
                                value={professional.Duration}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "category",
                                    e.target.value
                                  )
                                }
                              >
                                <option selected hidden>
                                  Select Duration (Month)
                                </option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                                <option>6</option>
                                <option>7</option>
                                <option>8</option>
                                <option>9</option>
                                <option>10</option>
                                <option>11</option>
                                <option>12</option>
                              </select>
                            </div>

                            <div className="AwardProfile_inputfield">
                              <label>Year of Completion</label>
                              <input
                                value={professional.year}
                                onChange={(e) =>
                                  handleInputChange(index, "year", e.target.value)
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="BasicProfile_inputfield">
                              <label>Upload Document</label>
                              <input
                                value={professional.Document}
                                style={{ display: "none" }}
                                onChange={changeHandler}
                                id="fileID"
                                placeholder="Enter UPI Id"
                                name="upiId"
                                type="file"
                              />

                              <div className="input">
                                <label id="upload" htmlFor="fileID">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <path
                                      d="M16 6V17.5C16 19.71 14.21 21.5 12 21.5C9.79 21.5 8 19.71 8 17.5L8 5C8 3.62 9.12 2.5 10.5 2.5C11.88 2.5 13 3.62 13 5V15.5C13 16.05 12.55 16.5 12 16.5C11.45 16.5 11 16.05 11 15.5V6H9.5V15.5C9.5 16.88 10.62 18 12 18C13.38 18 14.5 16.88 14.5 15.5L14.5 5C14.5 2.79 12.71 1 10.5 1C8.29 1 6.5 2.79 6.5 5L6.5 17.5C6.5 20.54 8.96 23 12 23C15.04 23 17.5 20.54 17.5 17.5V6H16Z"
                                      fill="black"
                                      fill-opacity="0.54"
                                    />
                                  </svg>
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="AwardProfile_Addmorebtn">
                            <p>Remove</p>
                            <button type="button">
                              {" "}
                              <svg
                                onClick={removeLastProfessional}
                                xmlns="http://www.w3.org/2000/svg"
                                width="40"
                                height="40"
                                viewBox="0 0 40 40"
                                fill="none"
                              >
                                <circle cx="20" cy="20" r="20" fill="#AD2F3B" />
                                <text
                                  x="50%"
                                  y="50%"
                                  text-anchor="middle"
                                  fill="white"
                                  font-size="24px"
                                  font-family="Arial"
                                  dy=".3em"
                                >
                                  -
                                </text>
                              </svg>
                            </button>
                          </div>
                        </>
                      )}
                    </React.Fragment>
                  ))}

                  {
                    //comment
                  }
                  {awardFormData.awards.map((award, index) => (
                    <React.Fragment key={index}>
                      <h4>Traditional Art Education +</h4>

                      {index === awardFormData.awards.length - 1 ? (
                        // last index => add plus button
                        <>
                          <div className="AwardProfile_Awarddetials">
                            <div className="AwardProfile_inputfield">
                              <label>Name of Course</label>
                              <input
                                value={award.title}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "title",
                                    e.target.value
                                  )
                                }
                                type="text"
                              ></input>
                            </div>

                            <div className="AwardProfile_inputfield">
                              <label>Specialisation </label>
                              <input
                                value={award.title}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "title",
                                    e.target.value
                                  )
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="AwardProfile_inputfield">
                              <label>Name Of Institute</label>
                              <input
                                value={award.title}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "institute",
                                    e.target.value
                                  )
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="AwardProfile_inputfield">
                              <label>Duration (Month)</label>
                              <select
                                value={award.category}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "category",
                                    e.target.value
                                  )
                                }
                              >
                                <option selected hidden>
                                  Select Duration (Month)
                                </option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                                <option>6</option>
                                <option>7</option>
                                <option>8</option>
                                <option>9</option>
                                <option>10</option>
                                <option>11</option>
                                <option>12</option>
                              </select>
                            </div>
                            {/* <div className="AwardProfile_inputfield">
                          <label>Name of the Stage</label>
                          <input value={award.stage} onChange={(e) => handleInputChange(index, "stage", e.target.value)} type="text"></input>
                        </div> */}
                            <div className="AwardProfile_inputfield">
                              <label>Year of Completion</label>
                              <input
                                value={award.year}
                                onChange={(e) =>
                                  handleInputChange(index, "year", e.target.value)
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="BasicProfile_inputfield">
                              <label>Upload Document</label>
                              <input
                                style={{ display: "none" }}
                                onChange={changeHandler}
                                id="fileID"
                                placeholder="Enter UPI Id"
                                name="upiId"
                                type="file"
                              />
                              <div className="input">
                                <label id="upload" htmlFor="fileID">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <path
                                      d="M16 6V17.5C16 19.71 14.21 21.5 12 21.5C9.79 21.5 8 19.71 8 17.5L8 5C8 3.62 9.12 2.5 10.5 2.5C11.88 2.5 13 3.62 13 5V15.5C13 16.05 12.55 16.5 12 16.5C11.45 16.5 11 16.05 11 15.5V6H9.5V15.5C9.5 16.88 10.62 18 12 18C13.38 18 14.5 16.88 14.5 15.5L14.5 5C14.5 2.79 12.71 1 10.5 1C8.29 1 6.5 2.79 6.5 5L6.5 17.5C6.5 20.54 8.96 23 12 23C15.04 23 17.5 20.54 17.5 17.5V6H16Z"
                                      fill="black"
                                      fill-opacity="0.54"
                                    />
                                  </svg>
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="AwardProfile_Addmorebtn">
                            <p>Add More Awards Details</p>
                            <button type="button">
                              {" "}
                              <svg
                                onClick={addProfessional}
                                xmlns="http://www.w3.org/2000/svg"
                                width="40"
                                height="40"
                                viewBox="0 0 40 40"
                                fill="none"
                              >
                                <circle cx="20" cy="20" r="20" fill="#AD2F3B" />
                                <text
                                  x="50%"
                                  y="50%"
                                  text-anchor="middle"
                                  fill="white"
                                  font-size="24px"
                                  font-family="Arial"
                                  dy=".3em"
                                >
                                  +
                                </text>
                              </svg>
                            </button>
                          </div>
                        </>
                      ) : (
                        // not last index => add - button
                        <>
                          <div className="AwardProfile_Awarddetials">
                            <div className="AwardProfile_inputfield">
                              <label>Name of Course</label>
                              <input
                                value={award.title}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "title",
                                    e.target.value
                                  )
                                }
                                type="text"
                              ></input>
                            </div>

                            <div className="AwardProfile_inputfield">
                              <label>Specialisation</label>
                              <input
                                value={award.title}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "title",
                                    e.target.value
                                  )
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="AwardProfile_inputfield">
                              <label>Name Of Institute</label>
                              <input
                                value={award.title}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "institute",
                                    e.target.value
                                  )
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="AwardProfile_inputfield">
                              <label>Duration (Month)</label>
                              <select
                                value={award.category}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "category",
                                    e.target.value
                                  )
                                }
                              >
                                <option selected hidden>
                                  Select Duration (Month)
                                </option>
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                                <option>6</option>
                                <option>7</option>
                                <option>8</option>
                                <option>9</option>
                                <option>10</option>
                                <option>11</option>
                                <option>12</option>
                              </select>
                            </div>

                            <div className="AwardProfile_inputfield">
                              <label>Year of Completion</label>
                              <input
                                value={award.year}
                                onChange={(e) =>
                                  handleInputChange(index, "year", e.target.value)
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="BasicProfile_inputfield">
                              <label>Upload Document</label>
                              <input
                                style={{ display: "none" }}
                                onChange={changeHandler}
                                id="fileID"
                                placeholder="Enter UPI Id"
                                name="upiId"
                                type="file"
                              />
                              <div className="input">
                                <label id="upload" htmlFor="fileID">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <path
                                      d="M16 6V17.5C16 19.71 14.21 21.5 12 21.5C9.79 21.5 8 19.71 8 17.5L8 5C8 3.62 9.12 2.5 10.5 2.5C11.88 2.5 13 3.62 13 5V15.5C13 16.05 12.55 16.5 12 16.5C11.45 16.5 11 16.05 11 15.5V6H9.5V15.5C9.5 16.88 10.62 18 12 18C13.38 18 14.5 16.88 14.5 15.5L14.5 5C14.5 2.79 12.71 1 10.5 1C8.29 1 6.5 2.79 6.5 5L6.5 17.5C6.5 20.54 8.96 23 12 23C15.04 23 17.5 20.54 17.5 17.5V6H16Z"
                                      fill="black"
                                      fill-opacity="0.54"
                                    />
                                  </svg>
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="AwardProfile_Addmorebtn">
                            <p>Remove</p>
                            <button type="button">
                              {" "}
                              <svg
                                onClick={removeLastProfessional}
                                xmlns="http://www.w3.org/2000/svg"
                                width="40"
                                height="40"
                                viewBox="0 0 40 40"
                                fill="none"
                              >
                                <circle cx="20" cy="20" r="20" fill="#AD2F3B" />
                                <text
                                  x="50%"
                                  y="50%"
                                  text-anchor="middle"
                                  fill="white"
                                  font-size="24px"
                                  font-family="Arial"
                                  dy=".3em"
                                >
                                  -
                                </text>
                              </svg>
                            </button>
                          </div>
                        </>
                      )}
                    </React.Fragment>
                  ))}

                  <button type="submit" className="updateBtn">
                    Update
                  </button>
                </form>
              </div>
            )}

            {/* this is for performance */}
            {activeSection === "performance" && (
              <div
      style={{ fontFamily: "Poppins" }}
      className="PerformanceProfile_Infoform"
    >
      <form onSubmit={perforSubmitHandler}>
        <h4>PERFORMANCE PROFILE</h4>

        <div className="PerformanceProfile_PerformInfo">
          <div className="BasicProfile_inputfield">
            <label>Affiliated To Any Group/Organization</label>
            <select
              onChange={perforChangeHandler}
              name={"affiliatedToAnyGroup"}
              value={performanceFormData.affiliatedToAnyGroup}
            >
              <option value="">Select</option>
              <option value={true}>Yes</option>
              <option value={false}>No</option>
            </select>
          </div>

          {(performanceFormData?.affiliatedToAnyGroup == "true" ||
            performanceFormData?.affiliatedToAnyGroup == true) && (
            <>
              <div className="BasicProfile_inputfield">
                <label>Name Of Artist Group/Organisation </label>
                <input
                  onChange={(e) =>
                    setPerformanceFormData({
                      ...performanceFormData,
                      nameOfArtistGroupOrg: e.target.value,
                    })
                  }
                  name="nameOfArtistGroupOrg"
                  value={performanceFormData.nameOfArtistGroupOrg}
                />
              </div>

              {/* <div className="BasicProfile_inputfield">
                <label>Location of Group/Organization</label>
                <select
                  onChange={perforChangeHandler}
                  name="locationOfGroupOrg"
                  value={performanceFormData.locationOfGroupOrg}
                >
                  <option value="">Select</option>
                  {MajorIndianCities.map((i, index) => (
                    <option key={index} value={i.city}>
                      {i}
                    </option>
                  ))}
                </select>
              </div> */}


                        <div className="BasicProfile_inputfield">
    <label>Location of Group/Organization</label>
    <Select
      name="groupLocation"
      value={
        basicFormData.groupLocation
          ? {
              value: basicFormData.groupLocation,
              label: basicFormData.groupLocation,
            }
          : null
      }
      onChange={(selected) =>
        setBasicFormData((prev) => ({
          ...prev,
          groupLocation: selected ? selected.value : "",
        }))
      }
      options={locationOptions}
      placeholder="Search & select location"
      isClearable
    />
  </div>

              <div className="BasicProfile_inputfield">
                <label htmlFor="">
                  Contact Number <span className="red">*</span>
                </label>
                <div style={{ display: "flex" }}>
                  <select
                    onChange={(e) => {
                      setPerformanceFormData((prev) => ({
                        ...prev,
                        countryCode: e.target.value,
                      }));
                    }}
                    name="countryCode"
                    value={performanceFormData?.countryCode}
                    defaultValue={"+91"}
                    style={{
                      width: "25%",
                      marginRight: "4px",
                      paddingRight: "2px",
                    }}
                  >
                    {numbersArray.map((number) => (
                      <option >
                        +91
                      </option>
                    ))}
                  </select>
                  <input
                    name="contactNumber"
                    maxLength={10}
                    pattern="[0-9]{10}"
                    onChange={(e) => {
                      setPerformanceFormData((prev) => ({
                        ...prev,
                        contactNumber: e.target.value,
                      }));
                    }}
                    value={performanceFormData?.contactNumber}
                    placeholder="1234567890"
                    style={{ width: "83%" }}
                    required
                  />
                </div>
              </div>

              {/* ✅ Only show these 3 fields if affiliated = YES */}
              <div className="BasicProfile_inputfield">
                <label>Name of Arts</label>
                <select
                  onChange={performanceInfohandler}
                  name="nameOfArts"
                  value={perfInfoData.nameOfArts}
                >
                  <option value="">Select</option>
                  {perfArtName.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>

              <div className="BasicProfile_inputfield">
                <label>Total no. of Artist</label>
                <select
                  onChange={performanceInfohandler}
                  name="totalNoOfArtists"
                  value={perfInfoData?.totalNoOfArtists}
                >
                  <option value="">Select</option>
                  {Array.from({ length: 20 }, (_, i) => i + 1).map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>

              <div className="BasicProfile_inputfield">
                <label>Type of Performance</label>
                <select
                  onChange={perforChangeHandler}
                  name="typeOfPerformance"
                  value={performanceFormData.typeOfPerformance}
                >
                  <option value="">Select</option>
                  <option value="solo">Solo</option>
                  <option value="group">Group</option>
                  <option value="both">Both</option>
                </select>
              </div>
            </>
          )}
      
    


                    <div className="BasicProfile_inputfield">
                      <label>Highest Level of Performance</label>
                      <select
                        onChange={perforChangeHandler}
                        name="highestLevelOfPerformance"
                        value={performanceFormData.highestLevelOfPerformance}
                      >
                        <option selected>Select</option>
                        <option value="International">International</option>
                        <option value="National">National</option>
                        <option value="State">State</option>
                        <option value="District">District</option>
                      </select>
                    </div>

                    <div className="BasicProfile_inputfield">
                      <label>
                        Total Number of Performance <span className="red">*</span>
                      </label>
                      <select
                        onChange={perforChangeHandler}
                        name="totalPerfs"
                        value={performanceFormData.totalPerfs}
                      >
                        <option value="" disabled selected>
                          Select
                        </option>
                        {[...Array(251).keys()].map((item, index) => {
                          if (item === 250) {
                            return (
                              <option key={item} value="250+">
                                250+
                              </option>
                            );
                          }
                          return (
                            <option key={item} value={item}>
                              {item}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="BasicProfile_inputfield">
                      <label>
                        No. of Years Of Experience <span className="red">*</span>{" "}
                      </label>
                      <select
                        onChange={perforChangeHandler}
                        name="experience"
                        value={performanceFormData.experience}
                      >
                        <option disabled>Select</option>
                        {[...Array(100).keys()].map((i) => (
                          <option key={i + 1} value={i + 1}>
                            {i + 1}
                          </option>
                        ))}
                        <option value="100+">100+</option>
                      </select>
                    </div>

                    <div className="BasicProfile_inputfield">
                      <label>Average Duration of Performance (India)</label>
                      <select
                        onChange={perforChangeHandler}
                        name="avgPerfDurationIn"
                        value={performanceFormData.avgPerfDurationIn}
                      >
                        <option selected>Select</option>
                        <option value="<10min">&lt; 10 Minutes</option>
                        <option value="10min">10 Minutes</option>
                        <option value="10-30min">10-30 Minutes</option>
                        <option value="30-60min">30-60 Minutes</option>
                        <option value="60-120min">60-120 Minutes</option>
                        <option value=">120min">&gt; 120 Minutes</option>
                      </select>
                    </div>
                    <div className="BasicProfile_inputfield">
                      <label>Average Fee Per Performance (India) </label>
                      <select
                        onChange={perforChangeHandler}
                        name="avgPerfFeeIn"
                        value={performanceFormData.avgPerfFeeIn}
                      >
                        <option selected>Select</option>
                        <option value="<5000">&lt; Rs 5000</option>
                        <option value="5000-10000">Rs 5000 - Rs 10000</option>
                        <option value="10000-20000">Rs 10000 - Rs 20000</option>
                        <option value="20000-50000">Rs 20000 - Rs 50000</option>
                        <option value="50000-100000">Rs 50000 - Rs 100000</option>
                        <option value=">100000">&gt; Rs 100000</option>
                      </select>
                    </div>

                    <div className="BasicProfile_inputfield">
                      <label>
                        Average Duration of Performance (International)
                      </label>
                      <select
                        onChange={perforChangeHandler}
                        name="avgPerfDurationInternational"
                        value={performanceFormData.avgPerfDurationInternational}
                      >
                        <option selected>Select</option>
                        <option value="<30min">&lt; 30 Minutes</option>
                        <option value="30-60min">30-60 Minutes</option>
                        <option value="60-120min">60-120 Minutes</option>
                        <option value=">120min">&gt; 120 Minutes</option>
                      </select>
                    </div>
                    <div className="BasicProfile_inputfield">
                      <label>Average Fee Per Performance (International)</label>
                      <select
                        onChange={perforChangeHandler}
                        name="avgPerfFeeInternational"
                        value={performanceFormData.avgPerfFeeInternational}
                      >
                        <option selected>Select</option>
                        <option value="<25000">&lt; Rs 25000</option>
                        <option value="25000-50000">Rs 25000 - Rs 50000</option>
                        <option value="50000-100000">Rs 50000 - Rs 100000</option>
                        <option value="100000-250000">
                          Rs 100000 - Rs 250000
                        </option>
                        <option value=">250000">&gt; Rs 250000</option>
                      </select>
                    </div>


                    <div>
                      <div className="award_plus_icon" onClick={toggleForm}>
                        <h4> Major Performances/ Events (Max. 3)</h4>
                        <div className="add-icon mobile">+</div>
                      </div>
                      <div className="award_table desktop">
                        <table className="performance_table">
                          <thead>
                            <tr>
                              <th>Name of Event</th>
                              <th>
                                Duration <br />
                                (Hour)
                              </th>
                              <th>Level</th>
                              <th>Location</th>
                              <th>
                                Partner/ <br /> Organizer
                              </th>
                            </tr>
                          </thead>
                          
                          <tbody>
    {tableData.map((row, rowIndex) => (
      <tr key={rowIndex}>
        <td>
          <input
            type="text"
            value={row.eventName || ""}
            onChange={(e) =>
              handlePerformanceTableChange(
                e,
                rowIndex,
                "eventName"
              )
            }
            placeholder="Enter event name"
            style={{ width: "100%", border: "none", padding: "5px" }}
          />
        </td>
        <td>
          <select
            style={{
              maxWidth: "150px",
              border: "none",
              padding: 0,
            }}
            value={row.duration || ""}
            onChange={(e) =>
              handlePerformanceTableChange(e, rowIndex, "duration")
            }
          >
            <option value="" hidden>
              Select
            </option>
            {months.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </td>
        <td>
          <select
            style={{
              maxWidth: "150px",
              border: "none",
              padding: 0,
            }}
            value={row.level || ""}
            onChange={(e) =>
              handlePerformanceTableChange(
                e,
                rowIndex,
                "level"
              )
            }
          >
            <option value="" hidden>
              Select
            </option>
            {[
              "International",
              "National",
              "State",
              "District",
              "Local",
            ].map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </td>
        {/* <td>
          <select
            style={{
              maxWidth: "150px",
              border: "none",
              padding: 0,
            }}
            value={row.location || ""}
            onChange={(e) =>
              handlePerformanceTableChange(
                e,
                rowIndex,
                "location"
              )
            }
          >
            <option value="" hidden>
              Select
            </option>
            {indian_states.map((item, index) => (
              <option key={index} value={item}>
                {item}
              </option>
            ))}
          </select>
        </td> */}


        <td>
    <select
      style={{ maxWidth: '150px', border: 'none', padding: 0 }}
      value={row.location}
      onChange={(e) => handlePerformanceTableChange(e, rowIndex, 'location')}
    >
      <option value="" hidden>
        Select option
      </option>
      {row.level === 'International'
        ? MajorInternationalCities.map((item, index) => (
            <option key={index} value={item}>
              {item}
            </option>
          ))
        : indian_states.map((item, index) => (
            <option key={index} value={item}>
              {item}
            </option>
          ))}
    </select>
  </td>

        <td>
          <input
            type="text"
            value={row.collaborator || ""}
            onChange={(e) =>
              handlePerformanceTableChange(
                e,
                rowIndex,
                "collaborator"
              )
            }
            placeholder="Enter partner"
            style={{ width: "100%", border: "none", padding: "5px" }}
          />
        </td>
      </tr>
    ))}
  </tbody>
                        </table>
                      </div>
                      {showForms.map((showForm, index) => (
                        <div
                          key={index}
                          className={`award_form mobile ${
                            showForm ? "show" : "hide"
                          }`}
                        >
                        {/*sharad mobile table */}
                          <div className="BasicProfile_inputfield">
                            <label htmlFor="Name of The Award">
                              Name of The Event
                            </label>
                            <input type="text" pattern="[a-zA-Z]+" />
                          </div>
                          <div className="BasicProfile_inputfield">
                            <label htmlFor="Awarding Body">
                              Duration (Month)
                            </label>
                            <select name="Duration">
                              <option selected hidden>
                                Select
                              </option>
                            </select>
                          </div>
                          <div className="BasicProfile_inputfield">
                            <label>Level</label>
                            <select name="level">
                              <option selected hidden>
                                Select
                              </option>
                            </select>
                          </div>
                          <div className="BasicProfile_inputfield">
                            <label>Location</label>
                            <select name="location">
                              <option selected hidden>
                                Select
                              </option>
                            </select>
                          </div>
                          <div className="BasicProfile_inputfield">
                            <label>Year</label>
                            <select name="year">
                              <option selected hidden>
                                Select
                              </option>
                            </select>
                          </div>
                          <div className="BasicProfile_inputfield">
                            <label>Media Links</label>
                            <input
                              style={{ display: "none" }}
                              onChange={() => {}}
                              id="fileID"
                              placeholder="Enter UPI Id"
                              name="upiId"
                              type="file"
                            />
                            <div className="input">
                              <label id="upload" htmlFor="fileID">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="30"
                                  height="30"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M16 6V17.5C16 19.71 14.21 21.5 12 21.5C9.79 21.5 8 19.71 8 17.5L8 5C8 3.62 9.12 2.5 10.5 2.5C11.88 2.5 13 3.62 13 5V15.5C13 16.05 12.55 16.5 12 16.5C11.45 16.5 11 16.05 11 15.5V6H9.5V15.5C9.5 16.88 10.62 18 12 18C13.38 18 14.5 16.88 14.5 15.5L14.5 5C14.5 2.79 12.71 1 10.5 1C8.29 1 6.5 2.79 6.5 5L6.5 17.5C6.5 20.54 8.96 23 12 23C15.04 23 17.5 20.54 17.5 17.5V6H16Z"
                                    fill="black"
                                    fillOpacity="0.54"
                                  />
                                </svg>
                              </label>
                            </div>
                          </div>
                          {showForms.length > 1 && (
                            <div className="another_mobile_div">
                              Major Performances Another input
                              <div
                                className="remove-icon mobile"
                                onClick={() => removeForm(index)}
                              >
                                -
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>

                  <div className="images">
    <div
      className="BasicProfile_inputfield"
      style={{ position: "relative" }}
    >
      <label
        htmlFor="performanceImages"
        className="custom-file-input"
      >
        Performance Photograph (Max 6)
      </label>

      <input
        className="performance_profile"
        style={{ color: "white", background: "none" }}
        onChange={handelMultipleImages}
        type="file"
        accept="image/*"
        multiple
        name="performanceImages"
        id="performanceImages"
      />

      <svg
        className="possso"
        xmlns="http://www.w3.org/2000/svg"
        height="16"
        width="14"
        viewBox="0 0 448 512"
      >
        <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
      </svg>
      <p style={{ fontSize: "10px", color: "red" }}>
        Each Image should be less than 1mb
      </p>
    </div>

    {performanceFormData?.performanceImages && 
    performanceFormData.performanceImages.length > 0 && (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
          gap: "15px",
          marginTop: "20px",
        }}
      >
        {performanceFormData.performanceImages.map((imageUrl, index) => (
          <div
            key={`perf-img-${index}`}
            style={{
              position: "relative",
              width: "100%",
              paddingBottom: "100%",
              borderRadius: "8px",
              overflow: "hidden",
              border: "2px solid #ddd",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              backgroundColor: "#f5f5f5",
            }}
          >
            <img
  src={
    imageUrl?.startsWith("http")
      ? imageUrl
      : `https://api.ekalakaar.com/images/${imageUrl}`
  }


    alt={`Performance ${index + 1}`}
    crossOrigin="anonymous"
    onError={(e) => {
      console.error(`Failed to load image ${index}:`, imageUrl);
      const filename = imageUrl.split("/").pop();

      // hide broken image
      e.target.style.display = "none";

      // create placeholder only once
      const parent = e.target.parentElement;
      if (parent && !parent.querySelector(".error-placeholder")) {
        const placeholder = document.createElement("div");
        placeholder.className = "error-placeholder";
        placeholder.style.cssText = `
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #999;
          font-size: 12px;
          padding: 10px;
          text-align: center;
          word-break: break-word;
        `;
        placeholder.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
            <circle cx="8.5" cy="8.5" r="1.5"></circle>
            <polyline points="21 15 16 10 5 21"></polyline>
          </svg>
          <div style="margin-top: 8px; font-size: 10px;">${filename}</div>
          <div style="margin-top: 4px; color: #f44336;">Image not found</div>
        `;
        parent.appendChild(placeholder);
      }
              }}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
            
            <button
              type="button"
              onClick={() => handleRemoveImage(index)}
              style={{
                position: "absolute",
                top: "8px",
                right: "8px",
                background: "#ef4444",
                border: "none",
                borderRadius: "50%",
                width: "32px",
                height: "32px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontSize: "20px",
                fontWeight: "bold",
                boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                transition: "all 0.2s ease",
                zIndex: 10,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#dc2626";
                e.currentTarget.style.transform = "scale(1.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "#ef4444";
                e.currentTarget.style.transform = "scale(1)";
              }}
            >
              ×
            </button>
          </div>
        ))}
      </div>
    )}

    {(!performanceFormData?.performanceImages || 
      performanceFormData.performanceImages.length === 0) && (
      <div style={{
        marginTop: "20px",
        padding: "20px",
        textAlign: "center",
        color: "#999",
        border: "2px dashed #ddd",
        borderRadius: "8px",
      }}>
        No images uploaded yet
      </div>
    )}
  </div>

                    <div className="BasicProfile_inputfield iiooo">
                      <label htmlFor="perfVideo">Performance Video(1)</label>
                      <input
                        value={perfVideo[0]}
                        onChange={(e) =>
                          handleInputChangeVideo(0, e.target.value)
                        }
                        id="perfVideo"
                        placeholder="Enter Video links"
                        name="perfVideo"
                        type="url"
                        className="perfino"
                      />
                    </div>

                    <div className="BasicProfile_inputfield iiooo">
                      <label htmlFor="perfVideo">Performance Video(2)</label>
                      <input
                        value={perfVideo[1]}
                        onChange={(e) =>
                          handleInputChangeVideo(1, e.target.value)
                        }
                        id="perfVideo"
                        placeholder="Enter Video links"
                        name="perfVideo"
                        type="url"
                        className="perfino"
                      />
                    </div>

                    <div className="BasicProfile_inputfield iiooo">
                      <label htmlFor="perfVideo">Performance Video(3)</label>
                      <input
                        value={perfVideo[2]}
                        onChange={(e) =>
                          handleInputChangeVideo(2, e.target.value)
                        }
                        id="perfVideo"
                        placeholder="Enter Video links"
                        name="perfVideo"
                        type="url"
                        className="perfino"
                      />
                    </div>
                    {/* <div className="PerformanceProfile_inputfield">
                  <label>Income for Performing Art*</label>
                  <select value={performanceFormData.averagePerformanceIncome} onChange={perforChangeHandler} name="averagePerformanceIncome">
                    <option selected >
                      Select average income
                    </option>
                    {ChargesPerPerformance.map((option) => (
            <option  value={option}>
              {option}
            </option>
          ))}
                  </select>
                </div> */}

                    <div style={{ width: "100%", marginTop: "20px" }}>
                      <label htmlFor="aboutJourney">
                        Highlights of your performance
                      </label>
                      <textarea
                        name="aboutJourney"
                        value={performanceFormData.aboutJourney}
                        onChange={(e) =>
                          setPerformanceFormData({
                            ...performanceFormData,
                            aboutJourney: e.target.value,
                          })
                        }
                        style={{
                          width: "100%",
                          border: "2px solid rgb(0,0,0,0.5)",
                          padding: "10px",
                          borderRadius: "10px",
                          resize: "none",
                          height: "166px",
                        }}
                      />
                    </div>
                  </div>
                  <h4></h4>
                                <div className="PerformanceProfile_PerformInfo">
    <div className="BasicProfile_inputfield">
      <label>Existing Production</label>
      <select
        onChange={performanceInfohandler}
        name="existingProductions"
        value={perfInfoData.existingProductions}
      >
        <option selected>Select</option>
        <option value="true">Yes</option>
        <option value="false">No</option>
      </select>
    </div>
    {(perfInfoData.existingProductions === "true" || perfInfoData.existingProductions === true) && (
      <>
        {/* Table for Multiple Productions */}
        <div
          className="award_plus_icon"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          <h4
            style={{
              color: "#AD2F3B",
              fontWeight: "600",
              margin: 0,
            }}
          >
            Existing Productions
          </h4>
          <div
            className="add-icon"
            onClick={addProductionRow}
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#AD2F3B",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            +
          </div>
        </div>

        {/* Desktop Table */}
        <div className="award_table desktop" style={{ marginTop: "10px" }}>
          <table className="performance_table">
            <thead>
              <tr>
                <th>Name of Production</th>
                <th>Brief of Performance</th>
                <th>Approx Budget (INR)</th>
                <th>Performance Link</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {productions.map((prod, index) => (
                <tr key={index}>
                  <td>
                    <input
                      type="text"
                      value={prod.nameOfProductions}
                      onChange={(e) => handleProductionChange(index, "nameOfProductions", e.target.value)}
                      placeholder="Enter name"
                    />
                  </td>
                  <td>
                    <textarea
                      value={prod.briefOfPerformance}
                      onChange={(e) => handleProductionChange(index, "briefOfPerformance", e.target.value)}
                      placeholder="Brief description"
                      rows="3"
                      style={{ width: "100%", border: "none" }}
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      value={prod.approxBudget}
                      onChange={(e) => handleProductionChange(index, "approxBudget", parseInt(e.target.value) || '')}
                      placeholder="Budget"
                    />
                  </td>
                  <td>
                    <input
                      type="url"
                      value={prod.sample || ""}
                      onChange={(e) => handleProductionChange(index, "sample", e.target.value)}
                      placeholder="Add Link here...."
                      style={{ width: "100%", padding: "5px" }}
                    />
                    {/* {prod.sample && (
                      <a 
                        href={prod.sample} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        style={{ 
                          fontSize: "11px", 
                          display: "block", 
                          marginTop: "5px",
                          color: "#AD2F3B",
                          textDecoration: "underline"
                        }}
                      >
                        🔗 View Link
                      </a>
                    )} */}
                  </td>
                  <td>
                    {productions.length > 1 && (
                      <button 
                        type="button" 
                        onClick={() => removeProductionRow(index)} 
                        style={{ 
                          background: "#ef4444", 
                          color: "white", 
                          border: "none", 
                          padding: "5px 10px",
                          borderRadius: "4px",
                          cursor: "pointer"
                        }}
                      >
                        -
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Form Version */}
        {productions.map((prod, index) => (
          <div key={index} className="award_form mobile show" style={{ marginTop: "10px" }}>
            <h5>Production {index + 1}</h5>
            <div className="BasicProfile_inputfield">
              <label>Name of Production</label>
              <input
                type="text"
                value={prod.nameOfProductions}
                onChange={(e) => handleProductionChange(index, "nameOfProductions", e.target.value)}
              />
            </div>
            <div className="BasicProfile_inputfield">
              <label>Brief of Performance</label>
              <textarea
                value={prod.briefOfPerformance}
                onChange={(e) => handleProductionChange(index, "briefOfPerformance", e.target.value)}
                rows="3"
              />
            </div>
            <div className="BasicProfile_inputfield">
              <label>Approx Budget (INR)</label>
              <input
                type="number"
                value={prod.approxBudget}
                onChange={(e) => handleProductionChange(index, "approxBudget", parseInt(e.target.value) || '')}
              />
            </div>
            <div className="BasicProfile_inputfield">
              <label>Performance Link</label>
              <input 
                type="url"
                value={prod.sample || ""}
                onChange={(e) => handleProductionChange(index, "sample", e.target.value)}
                placeholder="Add Link here..."
                style={{ width: "100%", padding: "8px", borderRadius: "5px", border: "1px solid #ccc" }}
              />
              {/* {prod.sample && (
                <a 
                  href={prod.sample} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  style={{ 
                    fontSize: "12px", 
                    marginTop: "8px", 
                    display: "inline-block",
                    color: "#AD2F3B",
                    textDecoration: "underline"
                  }}
                >
                  🔗 View Link
                </a>
              )} */}
            </div>
            {productions.length > 1 && (
              <div className="another_mobile_div">
                Remove Production {index + 1}
                <div className="remove-icon mobile" onClick={() => removeProductionRow(index)}>-</div>
              </div>
            )}
          </div>
        ))}
      </>
    )}
                                    </div>
                  <button className="updateBtn">Update</button>
                </form>
              </div>
            )}

            {/* this is for award  */}
            {activeSection === "award" && (
              <div
                style={{ fontFamily: "Poppins" }}
                className="AwardProfile_Infoform"
              >
                <form onSubmit={awardSubmitHandler}>
                  <h4>AWARD PROFILE</h4>
                  <div className="AwardProfile_AwardInfo">
                    <div className="BasicProfile_inputfield">
                      <label>Total Number of Awards</label>
                      <select
                        onChange={awardHandle}
                        name="totalAwards"
                        value={awardData.totalAwards}
                      >
                        <option value="" hidden>
                          Total Number of Awards
                        </option>
                        {[...Array(199).keys()].map((item) => {
                          const value = item + 1; // Adding 1 to start from 1 instead of 0
                          return (
                            <option key={value} value={value}>
                              {value}
                            </option>
                          );
                        })}
                        <option value="200">200</option>
                        <option value="200+">200+</option>
                      </select>
                    </div>
                    <div className="BasicProfile_inputfield">
                      <label>Highest Level of Awards </label>
                      <select
                        onChange={awardHandle}
                        name="level"
                        value={awardData.level}
                      >
                        <option selected hidden>
                          Highest Level of Awards
                        </option>
                        <option value="International">International</option>
                        <option value="National">National</option>
                        <option value="State">State</option>
                        <option value="District">District</option>
                        <option value="Taluka">Taluka</option>
                        <option value="Local">Local</option>
                        <option value="Others">Others</option>
                      </select>
                    </div>
                  
                    
                    
                    <div className="award_plus_icon" onClick={toggleForm}>
                      <h4>Major Awards</h4>
                      <div className="add-icon mobile">+</div>
                    </div>
                    <div className="award_table desktop">
                      <table className="performance_table">
                        <thead>
                          <tr>
                            <th> Award Name </th>
                            <th> Awarding Body</th>
                            <th> Level </th>
                            <th> Location</th>
                            <th> Year </th>
                            <th style={{wordBreak:"normal"}}> Upload Certificate </th>
                          </tr>
                        </thead>
                        <tbody>
                          {awardsTable.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                              {Object.keys(row).map((key, colIndex) => {
                                return (
                                  <td key={colIndex}>
                                    {key === "level" && (
                                      <select
                                        style={{
                                          maxWidth: "100px",
                                          border: "none",
                                          padding: 0,
                                        }}
                                        type="text"
                                        value={row[key]}
                                        defaultValue={awardData.highlight}
                                        onChange={(e) =>
                                          handleAwardTable(e, rowIndex, key)
                                        }
                                      >
                                        <option selected hidden>
                                          Select
                                        </option>
                                        {[
                                          "International",
                                          "National",
                                          "State",
                                          "District",
                                          "Local",
                                        ].map((item) => (
                                          <option key={item} value={item}>
                                            {item}
                                          </option>
                                        ))}
                                      </select>
                                    )}

                                    {(key == "awardingBody" ||
                                      key == "title") && (
                                      <input
                                        type="text"
                                        value={row[key]}
                                        defaultValue={awardData.highlight}
                                        onChange={(e) =>
                                          handleAwardTable(e, rowIndex, key)
                                        }
                                      />
                                    )}
  {key === "documentUrl" && (
    <div className="document-upload-wrapper">
      {/* + button jab file nahi hai */}
      {!row[key] && (
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            const fileInput =
              e.currentTarget.parentElement?.querySelector('input[type="file"]');
            fileInput?.click();
          }}
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            border: "none",
            backgroundColor: "#e53935", // red circle
            color: "#fff",
            fontSize: "24px",
            lineHeight: "40px",
            textAlign: "center",
            cursor: "pointer",
          }}
        >
          +
        </button>
      )}

      {/* hidden file input */}
      <input
        type="file"
        accept="image/*,application/pdf"
        style={{ display: "none" }}
        onChange={async (e) => {
          e.preventDefault();
          const file = e.target.files?.[0];
          if (!file) return;

          const maxSizeMB = 1;
          const maxSizeBytes = maxSizeMB * 1024 * 1024;
          if (file.size > maxSizeBytes) {
            alert(`File too large! Must be under ${maxSizeMB} MB.`);
            e.target.value = "";
            return;
          }

          const formData = new FormData();
          formData.append("documents", file);

          try {
            const res = await fetch(
              "https://api.ekalakaar.com/api/v1/artists/profile/award-documents/upload",
              {
                method: "POST",
                headers: { Authorization: `Bearer ${accessToken}` },
                body: formData,
              }
            );
            const data = await res.json();

            if (res.ok) {
              let fileUrl = data.images?.[0];
              if (fileUrl && !fileUrl.startsWith("http")) {
                fileUrl = `https://api.ekalakaar.com/images/${fileUrl}`;
              }
              const updated = [...awardsTable];
              updated[rowIndex][key] = fileUrl;
              setAwardTable(updated);
            } else {
              alert("Error uploading file. Please try again.");
            }
          } catch (err) {
            alert("Upload failed. Please try again.");
          }
        }}
      />

      {/* preview + remove */}
      {row[key] && (
        <div className="uploaded-document">
          <img
            src={
              row[key].startsWith("http")
                ? row[key]
                : `https://api.ekalakaar.com/images/${row[key]}`
            }
            alt="Uploaded"
            width="50"
            height="50"
            style={{ objectFit: "cover", borderRadius: "4px" }}
          />
          <button
            className="remove-cross"
            onClick={() => handleRemoveAwardDocument(rowIndex)}
          >
            ×
          </button>
        </div>
      )}
    </div>
  )}




                                    {key == "location" && (
                                      <select
                                        style={{
                                          maxWidth: "150px",
                                          border: "none",
                                          padding: 0,
                                        }}
                                        type="text"
                                        value={row[key]}
                                        defaultValue={awardData.highlight}
                                        onChange={(e) =>
                                          handleAwardTable(e, rowIndex, key)
                                        }
                                      >
                                        <option selected hidden>
                                          Select
                                        </option>
                                        {row.level == "International"
                                          ? MajorInternationalCities.map(
                                              (item, index) => (
                                                <option key={index} value={item}>
                                                  {item}
                                                </option>
                                              )
                                            )
                                          : indian_states.map((item, index) => (
                                              <option key={index} value={item}>
                                                {item}
                                              </option>
                                            ))}
                                      </select>
                                    )}
                                    {key == "year" && (
                                      <select
                                        style={{
                                          maxWidth: "150px",
                                          border: "none",
                                          padding: 0,
                                        }}
                                        type="text"
                                        value={row[key]}
                                        defaultValue={awardData.highlight}
                                        onChange={(e) =>
                                          handleAwardTable(e, rowIndex, key)
                                        }
                                      >
                                        <option selected hidden>
                                          Select
                                        </option>
                                        {completionYearData.map((item) => (
                                          <option key={item} value={item}>
                                            {item}
                                          </option>
                                        ))}
                                      </select>
                                    )}
                                    {key == "duration" && (
                                      <select
                                        style={{
                                          maxWidth: "150px",
                                          border: "none",
                                          padding: 0,
                                        }}
                                        type="text"
                                        value={row[key]}
                                        defaultValue={awardData.highlight}
                                        onChange={(e) =>
                                          handleAwardTable(e, rowIndex, key)
                                        }
                                      >
                                        <option selected hidden>
                                          Select
                                        </option>
                                        {[
                                          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,
                                        ].map((item) => (
                                          <option key={item} value={item}>
                                            {item}
                                          </option>
                                        ))}
                                      </select>
                                    )}
                                  </td>
                                );
                              })}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {showForms.map((showForm, index) => (
          <div key={index} className={`award_form mobile ${showForm ? 'show' : 'hide'}`}>
            <div className="BasicProfile_inputfield">
              <label htmlFor="Name of The Award">Name of The Award</label>
              <input type="text" pattern="[a-zA-Z]+" />
            </div>
            <div className="BasicProfile_inputfield">
              <label htmlFor="Awarding Body">Awarding Body</label>
              <input type="text" pattern="[a-zA-Z]+" />
            </div>
            <div className="BasicProfile_inputfield">
              <label>Level</label>
              <select name="level">
                <option selected hidden>Select</option>
                {['International', 'National', 'State', 'District', 'Local'].map((item, index) => (
                  <option key={index} value={item}>{item}</option>
                ))}
              </select>
            </div>
            <div className="BasicProfile_inputfield">
              <label>Location</label>
              <select name="location">
                <option selected hidden>Select</option>
                {/* Your options here, for example: */}
                {showForm.level === 'International'
                  ? MajorInternationalCities.map((item, index) => (
                      <option key={index} value={item}>{item}</option>
                    ))
                  : indian_states.map((item, index) => (
                      <option key={index} value={item}>{item}</option>
                    ))}
              </select>
            </div>
            <div className="BasicProfile_inputfield">
              <label>Year</label>
              <select name="year">
                <option selected hidden>Select</option>
                {/* Your options here */}
              </select>
            </div>
            <div className="BasicProfile_inputfield">
              <label>Upload Document</label>
              <input
                style={{ display: 'none' }}
                onChange={() => {}}
                id="fileID"
                placeholder="Enter UPI Id"
                name="upiId"
                type="file"
              />
              <div className="input">
                <label id="upload" htmlFor="fileID">
                  {/* Your SVG icon */}
                </label>
              </div>
            </div>
            {showForms.length > 1 && (
              <div className="another_mobile_div">
                Major Awards Another input
                <div
                  className="remove-icon mobile"
                  onClick={() => removeForm(index)}
                >
                  -
                </div>
              </div>
            )}
                      </div>
                    ))}
                  </div>
                  <div style={{ width: "100%", marginTop: "20px" }}>
                    <label htmlFor="aboutJourney">
                      Highlights of Awards (if any)
                    </label>
                    <textarea
                      onChange={awardHandle}
                      value={awardData.highlights}
                      name="highlights"
                      style={{
                        width: "100%",
                        border: "2px solid rgb(0,0,0,0.5)",
                        padding: "10px",
                        borderRadius: "10px",
                        resize: "none",
                        height: "166px",
                      }}
                    />
                  </div>

                  {awardFormData.awards.map((award, index) => (
                    <React.Fragment key={index}>
                      {index === awardFormData.awards.length - 1 ? (
                        // last index => add plus button
                        <>
                          <div className="AwardProfile_Awarddetials">
                            <div className="AwardProfile_inputfield">
                              <label>Name of Course</label>
                              <input
                                value={award.title}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "title",
                                    e.target.value
                                  )
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="AwardProfile_inputfield">
                              <label>Name Of Institute</label>
                              <input
                                value={award.title}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "Institute",
                                    e.target.value
                                  )
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="AwardProfile_inputfield">
                              <label>Name of Art</label>
                              <select
                                value={award.category}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "category",
                                    e.target.value
                                  )
                                }
                              >
                                <option selected hidden>
                                  Select Art
                                </option>
                                {nameofart.map((option) => (
                                  <option value={option}>{option}</option>
                                ))}
                              </select>
                            </div>
                            {/* <div className="AwardProfile_inputfield">
                          <label>Name of the Stage</label>
                          <input value={award.stage} onChange={(e) => handleInputChange(index, "stage", e.target.value)} type="text"></input>
                        </div> */}
                            <div className="AwardProfile_inputfield">
                              <label>Year of Completion</label>
                              <input
                                value={award.year}
                                onChange={(e) =>
                                  handleInputChange(index, "year", e.target.value)
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="AwardProfile_inputfield">
                              <label>Given By</label>
                              <input
                                value={award.givenBy}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "givenBy",
                                    e.target.value
                                  )
                                }
                                type="text"
                              ></input>
                            </div>
                          </div>

                          <div className="AwardProfile_Addmorebtn">
                            <p>Add More Awards Details</p>
                            <button type="button">
                              {" "}
                              <svg
                                onClick={addNewAward}
                                xmlns="http://www.w3.org/2000/svg"
                                width="40"
                                height="40"
                                viewBox="0 0 40 40"
                                fill="none"
                              >
                                <circle cx="20" cy="20" r="20" fill="#AD2F3B" />
                                <text
                                  x="50%"
                                  y="50%"
                                  text-anchor="middle"
                                  fill="white"
                                  font-size="24px"
                                  font-family="Arial"
                                  dy=".3em"
                                >
                                  +
                                </text>
                              </svg>
                            </button>
                          </div>
                        </>
                      ) : (
                        // not last index => add - button
                        <>
                          <div className="AwardProfile_Awarddetials">
                            <div className="AwardProfile_inputfield">
                              <label>Award Name</label>
                              <input
                                value={award.title}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "title",
                                    e.target.value
                                  )
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="AwardProfile_inputfield">
                              <label>Name Of Institute</label>
                              <input
                                value={award.title}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "institute",
                                    e.target.value
                                  )
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="AwardProfile_inputfield">
                              <label>Duration (Month)</label>
                              <select
                                value={award.category}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "category",
                                    e.target.value
                                  )
                                }
                              >
                                <option selected hidden>
                                  Select Duration (Month)
                                </option>
                              </select>
                            </div>
                            <div className="AwardProfile_inputfield">
                              <label>Year of Completion</label>
                              <input
                                value={award.stage}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "stage",
                                    e.target.value
                                  )
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="AwardProfile_inputfield">
                              <label>Award Year</label>
                              <input
                                value={award.year}
                                onChange={(e) =>
                                  handleInputChange(index, "year", e.target.value)
                                }
                                type="text"
                              ></input>
                            </div>
                            <div className="AwardProfile_inputfield">
                              <label>Given By</label>
                              <input
                                value={award.givenBy}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "givenBy",
                                    e.target.value
                                  )
                                }
                                type="text"
                              ></input>
                            </div>
                          </div>

                          <div className="AwardProfile_Addmorebtn">
                            <p>Remove</p>
                            <button type="button">
                              {" "}
                              <svg
                                onClick={removeLastAward}
                                xmlns="http://www.w3.org/2000/svg"
                                width="40"
                                height="40"
                                viewBox="0 0 40 40"
                                fill="none"
                              >
                                <circle cx="20" cy="20" r="20" fill="#AD2F3B" />
                                <text
                                  x="50%"
                                  y="50%"
                                  text-anchor="middle"
                                  fill="white"
                                  font-size="24px"
                                  font-family="Arial"
                                  dy=".3em"
                                >
                                  -
                                </text>
                              </svg>
                            </button>
                          </div>
                        </>
                      )}
                    </React.Fragment>
                  ))}

                  <button className="updateBtn">Update</button>
                </form>
              </div>
            )}
            {activeSection === "product" && (
              <div
                style={{ fontFamily: "Poppins" }}
                className="AwardProfile_Infoform"
              >
                <form className="create-product-form" onSubmit={handleProductSubmit}>
                  <div className="form-group">
                    <label>Title:</label>
                    <select value={selectedTitleName} name="title" onChange={handleTitleChange}>
                      <option value="">-- Select Category --</option>
                      {purpose.map((item) => (
                        <option key={item.category} value={item.category}>
                          {item.category}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Category:</label>
                    <select 
                      value={selectedCategoryName} 
                      onChange={handleCategoryChange}
                      disabled={!selectedTitleName}
                      name="category"
                    >
                      <option value="">-- Select Category --</option>
                      {currentCategoryObj?.subcategories.map((sub) => (
                        <option key={sub.name} value={sub.name}>
                          {sub.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Sub Category:</label>
                    <select 
                      value={selectedSubcategoryName} 
                      onChange={handleSubCategoryChange}
                      disabled={!selectedCategoryName}
                      name="subcategory"
                    >
                      <option value="">-- Select Subcategory --</option>
                      {currentSubcategoryObj?.artForms.map((sub) => (
                        <option key={sub} value={sub}>
                          {sub}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Language:</label>
                    <Select
                        styles={{ overflowY: "auto", height: "50px" }}
                        name="language"
                        defaultValue={languagesProductOptions}
                        value={languagesProductOptions}
                        onChange={handleLanguageChange}
                        options={languageOptions}
                      />
                  </div>

                  {/* <div className="form-group">
                    <label>Tags (comma separated):</label>
                    <input type="text" name="tags" value={formData.tags.join(', ')} onChange={(e) => handleArrayChange(e, 'tags')} />
                  </div> */}

                  <fieldset className="video-section">
                    <legend>Video Details</legend>
                    <div className="form-group">
                      <label>URL:</label>
                      <input type="url" name="url"  onChange={(e) => handleNestedChange(e, 'video')} required />
                    </div>
                    <div className="form-group">
                      <label>Trailer URL:</label>
                      <input type="url" name="trailerURL" onChange={(e) => handleNestedChange(e, 'video')} required />
                    </div>
                    {/* <div className="form-group">
                      <label>Visibility:</label>
                      <select name="visibility" value={formData.video.visibility} onChange={(e) => handleNestedChange(e, 'video')} required>
                        <option value="">Select</option>
                        <option value="private">Private</option>
                        <option value="unlisted">Unlisted</option>
                      </select>
                    </div> */}
                    <div className="form-group">
                      <label>Duration (seconds):</label>
                      <input type="number" name="duration"  onChange={(e) => handleNestedChange(e, 'video')} />
                    </div>
                    <div className="form-group">
                      <label>Quality:</label>
                      <select name="quality"  onChange={(e) => handleNestedChange(e, 'video')}>
                        <option value="">Select</option>
                        <option value="480p">480p</option>
                        <option value="720p">720p</option>
                        <option value="1080p">1080p</option>
                        <option value="4K">4K</option>
                      </select>
                    </div>
                  </fieldset>

                  <div className="form-group">
                    <label>Description:</label>
                    <textarea name="description" onChange={handleChange} required></textarea>
                  </div>

                  <div className="form-group">
                    <label>Mood Tags (Select any 5):</label>
                    {/* <input type="text" name="moodTags" value={formData.moodTags.join(', ')} onChange={(e) => handleArrayChange(e, 'moodTags')} /> */}
                    <Select
                      styles={{ overflowY: "auto", height: "50px", display:"flex", alignItems:"center" }}
                      defaultValue={moodsoptions}
                      value={moodsoptions}
                      isMulti
                      name="moods"
                      onChange={handleMoodChange}
                      options={moodOptions}
                      isOptionDisabled={(option) =>
                        moodsoptions.length >= 5 &&
                        !moodsoptions.some(
                          (selected) => selected.value === option.value
                        )
                      }
                    />
                    {moodsoptions.length >= 5 && (
                      <small style={{ color: "red" }}>
                        Maximum 5 moods can be selected.
                      </small>
                    )}
                  </div>

                  <fieldset className="pricing-section">
                    <legend>Pricing</legend>
                    <div className="form-group">
                      <label>Amount:</label>
                      <input type="number" name="pricing" onChange={(e) => handleNestedChange(e, 'pricing')} required />
                    </div>
                  </fieldset>

                  <button type="submit" className="submit-btn">Create Product</button>
                </form>
              </div>
            )}
          </div>
        </div>

      </div>

    </>
  );
}